/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccountOrder {
  IRA = "IRA",
  NONE = "NONE",
  PCA = "PCA",
  PCA_TREASURY = "PCA_TREASURY",
  PCA_YOUTH = "PCA_YOUTH",
  TPA = "TPA",
}

export enum AccountStage {
  ACCOUNT_ACTIVATED = "ACCOUNT_ACTIVATED",
  CLOSED = "CLOSED",
  DOCUMENTS_PENDING = "DOCUMENTS_PENDING",
  DOCUMENTS_SENT_TO_CLIENT = "DOCUMENTS_SENT_TO_CLIENT",
  DOCUMENTS_SENT_TO_CUSTODIAN = "DOCUMENTS_SENT_TO_CUSTODIAN",
  DOCUMENTS_SIGNED = "DOCUMENTS_SIGNED",
  NONE = "NONE",
  ONBOARDING_ACCOUNT_TYPE = "ONBOARDING_ACCOUNT_TYPE",
  ONBOARDING_BENEFICIARIES = "ONBOARDING_BENEFICIARIES",
  ONBOARDING_BUSINESS_INFORMATION = "ONBOARDING_BUSINESS_INFORMATION",
  ONBOARDING_CLIENT_AGREEMENTS = "ONBOARDING_CLIENT_AGREEMENTS",
  ONBOARDING_CONTACT_INFORMATION = "ONBOARDING_CONTACT_INFORMATION",
  ONBOARDING_FUNDING = "ONBOARDING_FUNDING",
  ONBOARDING_FUNDING_ACH_FORM = "ONBOARDING_FUNDING_ACH_FORM",
  ONBOARDING_FUNDING_CHECK_FORM = "ONBOARDING_FUNDING_CHECK_FORM",
  ONBOARDING_FUNDING_CRYPTO_FORM = "ONBOARDING_FUNDING_CRYPTO_FORM",
  ONBOARDING_FUNDING_TYPE = "ONBOARDING_FUNDING_TYPE",
  ONBOARDING_FUNDING_WIRE_FORM = "ONBOARDING_FUNDING_WIRE_FORM",
  ONBOARDING_GOVERNMENT_ID = "ONBOARDING_GOVERNMENT_ID",
  ONBOARDING_KYB = "ONBOARDING_KYB",
  ONBOARDING_KYC = "ONBOARDING_KYC",
  ONBOARDING_PERSONAL_INFORMATION = "ONBOARDING_PERSONAL_INFORMATION",
  PCA_CLIENT_AGREEMENT_SIGNED = "PCA_CLIENT_AGREEMENT_SIGNED",
  PCA_IMPORTANT_DISCLOSURES = "PCA_IMPORTANT_DISCLOSURES",
  PCA_TERMS_OF_SERVICE = "PCA_TERMS_OF_SERVICE",
  VERIFIED = "VERIFIED",
  WIZARD_STARTED = "WIZARD_STARTED",
}

export enum AccountStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  DELINQUENT = "DELINQUENT",
  DISABLED = "DISABLED",
  INTERNAL = "INTERNAL",
  IN_REVIEW = "IN_REVIEW",
  NONE = "NONE",
  PENDING = "PENDING",
}

export enum AccountType {
  ANNUITY = "ANNUITY",
  ANNUITY_ROTH = "ANNUITY_ROTH",
  ANNUITY_TRADITIONAL = "ANNUITY_TRADITIONAL",
  CHECKING = "CHECKING",
  CRYPTO_WALLET = "CRYPTO_WALLET",
  DEVELOPER_TEST = "DEVELOPER_TEST",
  DEVELOPER_TEST_PCA = "DEVELOPER_TEST_PCA",
  INHERITED_ROTH_IRA = "INHERITED_ROTH_IRA",
  INHERITED_TRADITIONAL_IRA = "INHERITED_TRADITIONAL_IRA",
  NONE = "NONE",
  NON_TAX_ADVANTAGED = "NON_TAX_ADVANTAGED",
  NOT_SPECIFIED = "NOT_SPECIFIED",
  OTHER = "OTHER",
  PENSION = "PENSION",
  PREMIUM_CUSTODY_ACCOUNT = "PREMIUM_CUSTODY_ACCOUNT",
  PREMIUM_CUSTODY_ACCOUNT_TREASURY = "PREMIUM_CUSTODY_ACCOUNT_TREASURY",
  ROTH401_K = "ROTH401_K",
  ROTH403_B = "ROTH403_B",
  ROTH457 = "ROTH457",
  ROTH_IRA = "ROTH_IRA",
  ROTH_TSP = "ROTH_TSP",
  SAVINGS = "SAVINGS",
  SEP_IRA = "SEP_IRA",
  SIMPLE_IRA = "SIMPLE_IRA",
  TPA = "TPA",
  TPA401_K = "TPA401_K",
  TPA_BENEFICIARY_ROTH = "TPA_BENEFICIARY_ROTH",
  TPA_BENEFICIARY_TRADITIONAL = "TPA_BENEFICIARY_TRADITIONAL",
  TPA_CESA = "TPA_CESA",
  TPA_HSA = "TPA_HSA",
  TPA_INHERITED_ROTH_IRA = "TPA_INHERITED_ROTH_IRA",
  TPA_INHERITED_TRADITIONAL_IRA = "TPA_INHERITED_TRADITIONAL_IRA",
  TPA_PCA = "TPA_PCA",
  TPA_ROTH401_K = "TPA_ROTH401_K",
  TPA_ROTH_IRA = "TPA_ROTH_IRA",
  TPA_SEP_IRA = "TPA_SEP_IRA",
  TPA_SIMPLE_IRA = "TPA_SIMPLE_IRA",
  TPA_SOLO_K = "TPA_SOLO_K",
  TPA_TRADITIONAL_IRA = "TPA_TRADITIONAL_IRA",
  TRADITIONAL401_K = "TRADITIONAL401_K",
  TRADITIONAL403_B = "TRADITIONAL403_B",
  TRADITIONAL457 = "TRADITIONAL457",
  TRADITIONAL_IRA = "TRADITIONAL_IRA",
  TRADITIONAL_TSP = "TRADITIONAL_TSP",
}

export enum AddressType {
  BILLING = "BILLING",
  BIRTH = "BIRTH",
  BUSINESS_PREVIOUS = "BUSINESS_PREVIOUS",
  BUSINESS_PRIMARY = "BUSINESS_PRIMARY",
  BUSINESS_SECONDARY = "BUSINESS_SECONDARY",
  EMPLOYER = "EMPLOYER",
  NONE = "NONE",
  OBSOLETE = "OBSOLETE",
  PREVIOUS = "PREVIOUS",
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  SHIPPING = "SHIPPING",
}

export enum BeneficiaryDirective {
  NONE = "NONE",
  OPTION_A = "OPTION_A",
  OPTION_B = "OPTION_B",
}

export enum BeneficiaryRelationshipType {
  NONE = "NONE",
  OTHER = "OTHER",
  SPOUSE = "SPOUSE",
}

export enum BeneficiaryStatus {
  ACTIVE = "ACTIVE",
  DECLINED = "DECLINED",
  INACTIVE = "INACTIVE",
  NONE = "NONE",
  PENDING = "PENDING",
}

export enum BeneficiaryType {
  CONTINGENT = "CONTINGENT",
  DECEASED = "DECEASED",
  NONE = "NONE",
  PRIMARY = "PRIMARY",
}

export enum BusinessType {
  CORPORATION = "CORPORATION",
  LIMITED_LIABILITY_COMPANY = "LIMITED_LIABILITY_COMPANY",
  NONE = "NONE",
  NON_PROFIT = "NON_PROFIT",
  PARTNERSHIP = "PARTNERSHIP",
  SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
  TRUST = "TRUST",
}

export enum ChurnReason {
  BULK_ACCOUNT_CLOSURE = "BULK_ACCOUNT_CLOSURE",
  CLIENT_DECEASED = "CLIENT_DECEASED",
  DISSATISFIED = "DISSATISFIED",
  INCOMPLETE_FUNDING = "INCOMPLETE_FUNDING",
  INCORRECT_ACCOUNT_TYPE = "INCORRECT_ACCOUNT_TYPE",
  INELIGIBLE = "INELIGIBLE",
  LOW_BALANCE = "LOW_BALANCE",
  MARKET_UNCERTAINTY = "MARKET_UNCERTAINTY",
  NONE = "NONE",
  OTHER = "OTHER",
  OVER_CONTRIBUTED = "OVER_CONTRIBUTED",
  RETIREMENT_INCOME = "RETIREMENT_INCOME",
}

export enum ConditionalTransactionStatus {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  EXECUTED = "EXECUTED",
  EXECUTING = "EXECUTING",
  FAILED = "FAILED",
  NONE = "NONE",
}

export enum ConditionalTransactionTriggerPoint {
  HIGHER = "HIGHER",
  LOWER = "LOWER",
  NONE = "NONE",
}

export enum ContributionType {
  NONE = "NONE",
  SELF = "SELF",
  SPOUSE = "SPOUSE",
}

export enum CrmUserStatus {
  ACTIVE = "ACTIVE",
  AUTH_LOGIN = "AUTH_LOGIN",
  AUTH_VERIFY = "AUTH_VERIFY",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  EMAIL_VERIFY = "EMAIL_VERIFY",
  NONE = "NONE",
}

export enum CurrencyFeature {
  CONDITIONAL_BUY = "CONDITIONAL_BUY",
  CONDITIONAL_DISPLAY = "CONDITIONAL_DISPLAY",
  CONDITIONAL_SELL = "CONDITIONAL_SELL",
  FUNDING = "FUNDING",
  MARKET_ORDER_BUY = "MARKET_ORDER_BUY",
  MARKET_ORDER_DISPLAY = "MARKET_ORDER_DISPLAY",
  MARKET_ORDER_SELL = "MARKET_ORDER_SELL",
  METAL_DISPLAY = "METAL_DISPLAY",
  NONE = "NONE",
  PCA_CRYPTO_DEPOSIT = "PCA_CRYPTO_DEPOSIT",
  RECURRING_PURCHASE = "RECURRING_PURCHASE",
  RECURRING_PURCHASE_DISPLAY = "RECURRING_PURCHASE_DISPLAY",
  STAKING = "STAKING",
  STAKING_DISPLAY = "STAKING_DISPLAY",
  YIELD = "YIELD",
  YIELD_DISPLAY = "YIELD_DISPLAY",
}

export enum CustodianType {
  ADVANTA = "ADVANTA",
  APEX = "APEX",
  EXTERNAL = "EXTERNAL",
  FORTRESS = "FORTRESS",
  HORIZON = "HORIZON",
  I_TRUST = "I_TRUST",
  M2 = "M2",
  MADISON = "MADISON",
  MOUNTAIN_WEST = "MOUNTAIN_WEST",
  NEXT_GENERATION = "NEXT_GENERATION",
  NONE = "NONE",
}

export enum DocuSignClickwrapTemplateType {
  NONE = "NONE",
  PCA_AGREEMENT = "PCA_AGREEMENT",
  PCA_BUSINESS_AGREEMENT = "PCA_BUSINESS_AGREEMENT",
  PCA_INDIVIDUAL_AGREEMENT = "PCA_INDIVIDUAL_AGREEMENT",
  PCA_TREASURY_AGREEMENT = "PCA_TREASURY_AGREEMENT",
  ROTH_CONVERSION_AGREEMENT = "ROTH_CONVERSION_AGREEMENT",
  ROTH_IRA_AGREEMENT = "ROTH_IRA_AGREEMENT",
  SEP_IRA_AGREEMENT = "SEP_IRA_AGREEMENT",
  TRAD_IRA_AGREEMENT = "TRAD_IRA_AGREEMENT",
}

export enum DocuSignStatus {
  AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED",
  AUTO_RESPONDED = "AUTO_RESPONDED",
  COMPLETED = "COMPLETED",
  CORRECT = "CORRECT",
  CREATED = "CREATED",
  DECLINED = "DECLINED",
  DELETED = "DELETED",
  DELIVERED = "DELIVERED",
  PROCESSING = "PROCESSING",
  SENT = "SENT",
  SIGNED = "SIGNED",
  TEMPLATE = "TEMPLATE",
  VOIDED = "VOIDED",
}

export enum DocuSignTemplateType {
  ACCOUNT_CHANGES = "ACCOUNT_CHANGES",
  CARES_ACT = "CARES_ACT",
  CONVERSION = "CONVERSION",
  DISTRIBUTION = "DISTRIBUTION",
  INDEMNIFICATION_LETTER = "INDEMNIFICATION_LETTER",
  IRA_ADOPTION_AGREEMENT = "IRA_ADOPTION_AGREEMENT",
  KINGDOM_TRUST_INDEMNIFICATION_LETTER = "KINGDOM_TRUST_INDEMNIFICATION_LETTER",
  NONE = "NONE",
  PRECIOUS_METALS_DISTRIBUTION = "PRECIOUS_METALS_DISTRIBUTION",
  RECHARACTERIZATION_REQUEST = "RECHARACTERIZATION_REQUEST",
  ROTH60_DAY_ROLLOVER = "ROTH60_DAY_ROLLOVER",
  ROTH_CONVERSION = "ROTH_CONVERSION",
  SUPPLEMENTAL_CURRENCIES = "SUPPLEMENTAL_CURRENCIES",
  TRADITIONAL60_DAY_ROLLOVER = "TRADITIONAL60_DAY_ROLLOVER",
}

export enum DocumentStage {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  DRAFT = "DRAFT",
  NONE = "NONE",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  SENT_TO_CLIENT = "SENT_TO_CLIENT",
  SENT_TO_CUSTODIAN = "SENT_TO_CUSTODIAN",
  SIGNED = "SIGNED",
  VOIDED = "VOIDED",
}

export enum DocumentStatus {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  NONE = "NONE",
  PENDING = "PENDING",
  VOIDED = "VOIDED",
}

export enum DocumentType {
  CLICKWRAP = "CLICKWRAP",
  DOCU_SIGN = "DOCU_SIGN",
  FILE = "FILE",
  KYB = "KYB",
  NONE = "NONE",
  OTHER = "OTHER",
  PDF = "PDF",
  WIZARD_PDF = "WIZARD_PDF",
}

export enum EmailAddressType {
  BCC = "BCC",
  CC = "CC",
  FROM = "FROM",
  NONE = "NONE",
  TO = "TO",
}

export enum EmailStatus {
  CREATED = "CREATED",
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  NONE = "NONE",
  SENT = "SENT",
}

export enum EmailTemplateType {
  ACCOUNT_ACTIVE = "ACCOUNT_ACTIVE",
  ACCOUNT_CREATION = "ACCOUNT_CREATION",
  ACH_TRANSFER_COMPLETED_EXTERNAL = "ACH_TRANSFER_COMPLETED_EXTERNAL",
  ACH_TRANSFER_FAILED_EXTERNAL = "ACH_TRANSFER_FAILED_EXTERNAL",
  ACH_TRANSFER_FAILED_INTERNAL = "ACH_TRANSFER_FAILED_INTERNAL",
  ACH_TRANSFER_PROCESSING_EXTERNAL = "ACH_TRANSFER_PROCESSING_EXTERNAL",
  ALGO_MANA_ENABLED_UPDATE = "ALGO_MANA_ENABLED_UPDATE",
  ALLOY_KYC_STATUS_DENIED = "ALLOY_KYC_STATUS_DENIED",
  APEX_TRANSFER_FORM_FURTHER_STEPS = "APEX_TRANSFER_FORM_FURTHER_STEPS",
  ASSET_TRANSFER_PENDING = "ASSET_TRANSFER_PENDING",
  ASTRA_ACH_COMPLETED = "ASTRA_ACH_COMPLETED",
  ASTRA_ACH_FAILED = "ASTRA_ACH_FAILED",
  ASTRA_ACH_STARTED = "ASTRA_ACH_STARTED",
  CASH_CONTRIBUTION_TRANSFER_PENDING = "CASH_CONTRIBUTION_TRANSFER_PENDING",
  CHECK_RECEIVED = "CHECK_RECEIVED",
  CONDITIONAL_TRANSACTION_CANCELED = "CONDITIONAL_TRANSACTION_CANCELED",
  CONDITIONAL_TRANSACTION_CREATED = "CONDITIONAL_TRANSACTION_CREATED",
  CONDITIONAL_TRANSACTION_ERROR = "CONDITIONAL_TRANSACTION_ERROR",
  CONDITIONAL_TRANSACTION_FAILED = "CONDITIONAL_TRANSACTION_FAILED",
  DOCUMENTS_PENDING = "DOCUMENTS_PENDING",
  DOCUMENTS_SENT_TO_CLIENT = "DOCUMENTS_SENT_TO_CLIENT",
  FILE_NOTICE = "FILE_NOTICE",
  FLR_DISTRIBUTION_NOTICE = "FLR_DISTRIBUTION_NOTICE",
  FORTRESS_ANNOUNCEMENT = "FORTRESS_ANNOUNCEMENT",
  FORTRESS_FUNDING_CONTRIBUTION = "FORTRESS_FUNDING_CONTRIBUTION",
  FORTRESS_FUNDING_ROLLOVER = "FORTRESS_FUNDING_ROLLOVER",
  FORTRESS_INTEGRATION = "FORTRESS_INTEGRATION",
  FORTRESS_INTEGRATION_UPDATE = "FORTRESS_INTEGRATION_UPDATE",
  FUNDING_APPROVED = "FUNDING_APPROVED",
  FUNDING_CONTRIBUTION = "FUNDING_CONTRIBUTION",
  FUNDING_ROLLOVER = "FUNDING_ROLLOVER",
  GOOGLE_REVIEWS = "GOOGLE_REVIEWS",
  INACTIVE_ACCOUNT = "INACTIVE_ACCOUNT",
  INSUFFICIENT_FUNDS_ACH = "INSUFFICIENT_FUNDS_ACH",
  INVITATION_VIA_REFERRAL = "INVITATION_VIA_REFERRAL",
  IRA_ADOPTION_AGREEMENT = "IRA_ADOPTION_AGREEMENT",
  IRA_CUSTODIAN_CHANGES = "IRA_CUSTODIAN_CHANGES",
  ITC_FUNDING_CONTRIBUTION = "ITC_FUNDING_CONTRIBUTION",
  ITC_FUNDING_ROLLOVER = "ITC_FUNDING_ROLLOVER",
  ITC_FUNDING_TRANSFER = "ITC_FUNDING_TRANSFER",
  ITC_SSN_VERIFICATION = "ITC_SSN_VERIFICATION",
  ITC_TRANSFER_RECEIPT = "ITC_TRANSFER_RECEIPT",
  MARKET_ORDER_CONFIRMATION = "MARKET_ORDER_CONFIRMATION",
  MARKET_ORDER_FAILED = "MARKET_ORDER_FAILED",
  MERGED_ACCOUNTS = "MERGED_ACCOUNTS",
  MERGE_ACCOUNTS_ANNOUNCEMENT1 = "MERGE_ACCOUNTS_ANNOUNCEMENT1",
  MERGE_ACCOUNTS_ANNOUNCEMENT2 = "MERGE_ACCOUNTS_ANNOUNCEMENT2",
  MERGE_ACCOUNTS_ANNOUNCEMENT3 = "MERGE_ACCOUNTS_ANNOUNCEMENT3",
  MICRO_TEST_CONFIRMATION = "MICRO_TEST_CONFIRMATION",
  NONE = "NONE",
  PCA_ASTRA_ACH_COMPLETED = "PCA_ASTRA_ACH_COMPLETED",
  PCA_ASTRA_ACH_STARTED = "PCA_ASTRA_ACH_STARTED",
  PCA_FUNDING_INSTRUCTION = "PCA_FUNDING_INSTRUCTION",
  PCA_TREASURY_ACCOUNT_APPROVED = "PCA_TREASURY_ACCOUNT_APPROVED",
  PCA_TREASURY_ACCOUNT_DENIED = "PCA_TREASURY_ACCOUNT_DENIED",
  PCA_TREASURY_ACCOUNT_IN_REVIEW = "PCA_TREASURY_ACCOUNT_IN_REVIEW",
  PCA_WIZARD_COMPLETED = "PCA_WIZARD_COMPLETED",
  POST_FUNDING_VIA_AFFILIATE = "POST_FUNDING_VIA_AFFILIATE",
  POST_FUNDING_VIA_REFERRAL = "POST_FUNDING_VIA_REFERRAL",
  POST_SIGN_UP_VIA_AFFILIATE = "POST_SIGN_UP_VIA_AFFILIATE",
  POST_SIGN_UP_VIA_REFERRAL = "POST_SIGN_UP_VIA_REFERRAL",
  RECURRING_PURCHASE_CANCELED = "RECURRING_PURCHASE_CANCELED",
  RECURRING_PURCHASE_CREATED = "RECURRING_PURCHASE_CREATED",
  RECURRING_PURCHASE_FAILED = "RECURRING_PURCHASE_FAILED",
  RECURRING_PURCHASE_HISTORY_FAILED = "RECURRING_PURCHASE_HISTORY_FAILED",
  REVIEW_REQUEST = "REVIEW_REQUEST",
  REVIEW_THANK_YOU = "REVIEW_THANK_YOU",
  RIA_CLIENT_CREATED = "RIA_CLIENT_CREATED",
  ROGUE_FUNDING_CRYPTO_TRANSACTION = "ROGUE_FUNDING_CRYPTO_TRANSACTION",
  ROLLOVER_ELIGIBILITY = "ROLLOVER_ELIGIBILITY",
  ROLLOVER_TRANSFER_PENDING = "ROLLOVER_TRANSFER_PENDING",
  ROTH_ROLLOVER_CONVERSION_ELIGIBILITY = "ROTH_ROLLOVER_CONVERSION_ELIGIBILITY",
  ROTH_TRAD_CONVERSION_ELIGIBILITY = "ROTH_TRAD_CONVERSION_ELIGIBILITY",
  STABLE_COIN_CONVERSION_CONFIRMATION = "STABLE_COIN_CONVERSION_CONFIRMATION",
  STAKING_ENROLLMENT_CANCEL = "STAKING_ENROLLMENT_CANCEL",
  STAKING_ENROLLMENT_CANCELLED = "STAKING_ENROLLMENT_CANCELLED",
  STAKING_ENROLLMENT_COMPLETED = "STAKING_ENROLLMENT_COMPLETED",
  STAKING_ENROLLMENT_START = "STAKING_ENROLLMENT_START",
  STAKING_ENROLLMENT_SUBMITTED = "STAKING_ENROLLMENT_SUBMITTED",
  STAKING_REWARD_DISBURSEMENT = "STAKING_REWARD_DISBURSEMENT",
  STAKING_TERM_COMPLETE = "STAKING_TERM_COMPLETE",
  STAKING_TERM_START = "STAKING_TERM_START",
  STAKING_UNSTAKING_SUBMITTED = "STAKING_UNSTAKING_SUBMITTED",
  TCA_FUNDING_INSTRUCTION = "TCA_FUNDING_INSTRUCTION",
  TEST_ACCOUNT_ADDED = "TEST_ACCOUNT_ADDED",
  TEST_ACCOUNT_NEW_FUNDING = "TEST_ACCOUNT_NEW_FUNDING",
  TPA_CLIENT_CREATED = "TPA_CLIENT_CREATED",
  TRADE_CONFIRMATION = "TRADE_CONFIRMATION",
  TRANSFER_FORM_FOLLOW_UP = "TRANSFER_FORM_FOLLOW_UP",
  TRANSFER_FORM_FURTHER_STEPS = "TRANSFER_FORM_FURTHER_STEPS",
  TREASURY_ACCOUNT_APPROVED = "TREASURY_ACCOUNT_APPROVED",
  TREASURY_ACCOUNT_DENIED = "TREASURY_ACCOUNT_DENIED",
  TREASURY_ACCOUNT_IN_REVIEW = "TREASURY_ACCOUNT_IN_REVIEW",
  UPDATE_ON_ALGO_AND_MANA = "UPDATE_ON_ALGO_AND_MANA",
  UPDATE_REGARDING_ALGO_AND_MANA = "UPDATE_REGARDING_ALGO_AND_MANA",
  VERIFICATION = "VERIFICATION",
  VERIFICATION_ADDRESS = "VERIFICATION_ADDRESS",
  VERIFICATION_DRIVERS_LICENSE = "VERIFICATION_DRIVERS_LICENSE",
  VERIFICATION_SSN = "VERIFICATION_SSN",
  WIZARD_COMPLETED = "WIZARD_COMPLETED",
  WIZARD_COMPLETION_CLIENT = "WIZARD_COMPLETION_CLIENT",
  YIELD_ENROLLMENT_CANCELLED = "YIELD_ENROLLMENT_CANCELLED",
  YIELD_ENROLLMENT_COMPLETED = "YIELD_ENROLLMENT_COMPLETED",
  YIELD_ENROLLMENT_SUBMITTED = "YIELD_ENROLLMENT_SUBMITTED",
  YIELD_REWARD_DISBURSEMENT = "YIELD_REWARD_DISBURSEMENT",
  YIELD_UNENROLLMENT_SUBMITTED = "YIELD_UNENROLLMENT_SUBMITTED",
}

export enum EmploymentStatus {
  EMPLOYED = "EMPLOYED",
  NONE = "NONE",
  RETIRED = "RETIRED",
  UNEMPLOYED = "UNEMPLOYED",
}

export enum FileTemplateType {
  BENEFICIARY_DESIGNATION_SPOUSAL_CONSENT_FORM = "BENEFICIARY_DESIGNATION_SPOUSAL_CONSENT_FORM",
  CASH_CONTRIBUTION_FUNDING_INSTRUCTIONS = "CASH_CONTRIBUTION_FUNDING_INSTRUCTIONS",
  GOVERNMENT_ID = "GOVERNMENT_ID",
  GOVERNMENT_ID_BACK = "GOVERNMENT_ID_BACK",
  INHERITED_IRA_TRANSFER_FORM = "INHERITED_IRA_TRANSFER_FORM",
  MONTHLY_ACCOUNT_STATEMENT = "MONTHLY_ACCOUNT_STATEMENT",
  NONE = "NONE",
  OTHER = "OTHER",
  PASSPORT = "PASSPORT",
  PASSPORT_BACK = "PASSPORT_BACK",
  PREMIUM_CUSTODY_ACCOUNT_WITHDRAWAL = "PREMIUM_CUSTODY_ACCOUNT_WITHDRAWAL",
  PREVIOUS_STATEMENT = "PREVIOUS_STATEMENT",
  REFUND_CONTRIBUTION = "REFUND_CONTRIBUTION",
  ROLLOVER_FUNDING_INSTRUCTIONS = "ROLLOVER_FUNDING_INSTRUCTIONS",
  SELFIE = "SELFIE",
  SSN_CARD = "SSN_CARD",
  TPA_AGREEMENT = "TPA_AGREEMENT",
  TRANSFER_FORM = "TRANSFER_FORM",
  UTILITY_BILL = "UTILITY_BILL",
  VENDOR_RECONCILIATION = "VENDOR_RECONCILIATION",
}

export enum FundingDirection {
  INBOUND = "INBOUND",
  NONE = "NONE",
  OUTBOUND = "OUTBOUND",
}

export enum FundingInstructionType {
  CRYPTO = "CRYPTO",
  FIAT = "FIAT",
  NONE = "NONE",
}

/**
 * This will be removed on FundingV2. Use FundingStatus instead.
 */
export enum FundingStage {
  ACCOUNT_PENDING = "ACCOUNT_PENDING",
  ASSET_TRANSFER_COMPLETED = "ASSET_TRANSFER_COMPLETED",
  ASSET_TRANSFER_PENDING = "ASSET_TRANSFER_PENDING",
  ASSET_TRANSFER_READY = "ASSET_TRANSFER_READY",
  CANCELED = "CANCELED",
  DECLINED = "DECLINED",
  DOCUMENTS_PENDING = "DOCUMENTS_PENDING",
  DOCUMENTS_SENT_TO_CLIENT = "DOCUMENTS_SENT_TO_CLIENT",
  DOCUMENTS_SENT_TO_CUSTODIAN = "DOCUMENTS_SENT_TO_CUSTODIAN",
  DOCUMENTS_SIGNED = "DOCUMENTS_SIGNED",
  DOCUMENT_REVIEW = "DOCUMENT_REVIEW",
  NONE = "NONE",
  PENDING_REVIEW = "PENDING_REVIEW",
  WAITING_TO_PROCESS = "WAITING_TO_PROCESS",
}

export enum FundingStatus {
  APPROVED = "APPROVED",
  APPROVED_THEN_DECLINED = "APPROVED_THEN_DECLINED",
  CANCELED = "CANCELED",
  CORRECTED = "CORRECTED",
  DECLINED = "DECLINED",
  DOCUMENTS_RECEIVED = "DOCUMENTS_RECEIVED",
  DOCUMENTS_SENT = "DOCUMENTS_SENT",
  IN_PROGRESS = "IN_PROGRESS",
  IN_REVIEW = "IN_REVIEW",
  NONE = "NONE",
  PENDING = "PENDING",
  PREFUNDED = "PREFUNDED",
  PREFUNDED_THEN_DECLINED = "PREFUNDED_THEN_DECLINED",
  PROCESSING = "PROCESSING",
  SIGNATURE_REQUIRED = "SIGNATURE_REQUIRED",
  STAMP_REQUIRED = "STAMP_REQUIRED",
  VERIFICATION = "VERIFICATION",
  WAITING_FOR_FUNDS = "WAITING_FOR_FUNDS",
}

export enum FundingTransactionStatus {
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  DECLINED = "DECLINED",
  NONE = "NONE",
  PENDING = "PENDING",
  TRANSACTION_READY = "TRANSACTION_READY",
}

export enum FundingTransactionType {
  CORRECTION = "CORRECTION",
  DEPOSIT = "DEPOSIT",
  FEDERAL_WITHHOLDING = "FEDERAL_WITHHOLDING",
  FORTRESS_EXIT_FEE = "FORTRESS_EXIT_FEE",
  MICRO_TEST = "MICRO_TEST",
  NONE = "NONE",
  OTHER = "OTHER",
  PROCESSING_FEE = "PROCESSING_FEE",
  RETURN_OF_FUNDS = "RETURN_OF_FUNDS",
  STATE_WITHHOLDING = "STATE_WITHHOLDING",
  WITHDRAWAL = "WITHDRAWAL",
}

export enum FundingType {
  ACCOUNT_CLOSURE = "ACCOUNT_CLOSURE",
  ASSET_DISTRIBUTION = "ASSET_DISTRIBUTION",
  CHARGEBACK = "CHARGEBACK",
  CONTRIBUTION = "CONTRIBUTION",
  CONVERSION = "CONVERSION",
  CORRECTION = "CORRECTION",
  DISTRIBUTION = "DISTRIBUTION",
  FORTRESS_EXIT_FEE = "FORTRESS_EXIT_FEE",
  FORTRESS_FEE_REFUND = "FORTRESS_FEE_REFUND",
  LOW_BALANCE = "LOW_BALANCE",
  NONE = "NONE",
  OTHER = "OTHER",
  PCA_CRYPTO = "PCA_CRYPTO",
  PCA_USD = "PCA_USD",
  RECHARACTERIZATION = "RECHARACTERIZATION",
  REFUND_CONTRIBUTION = "REFUND_CONTRIBUTION",
  RETURN_OF_FUNDS = "RETURN_OF_FUNDS",
  REWARD = "REWARD",
  RIA_TRANSFER = "RIA_TRANSFER",
  ROLLOVER = "ROLLOVER",
  TOKEN_MIGRATION = "TOKEN_MIGRATION",
  TPA_TRANSFER = "TPA_TRANSFER",
  TRANSFER = "TRANSFER",
}

export enum FundingV2Type {
  ACCOUNT_CLOSURE = "ACCOUNT_CLOSURE",
  CONTRIBUTION = "CONTRIBUTION",
  CONVERSION = "CONVERSION",
  DISTRIBUTION = "DISTRIBUTION",
  NONE = "NONE",
  OTHER = "OTHER",
  PCA_CRYPTO = "PCA_CRYPTO",
  PCA_USD = "PCA_USD",
  RECHARACTERIZATION = "RECHARACTERIZATION",
  REWARD = "REWARD",
  RIA_TRANSFER = "RIA_TRANSFER",
  ROLLOVER = "ROLLOVER",
  TOKEN_MIGRATION = "TOKEN_MIGRATION",
  TPA_TRANSFER = "TPA_TRANSFER",
  TRANSFER = "TRANSFER",
}

export enum IdentificationStatus {
  APPROVED = "APPROVED",
  NEEDS_APPROVAL = "NEEDS_APPROVAL",
  NONE = "NONE",
  REJECTED = "REJECTED",
}

export enum IraTransferInstruction {
  CASH_TRANSFER = "CASH_TRANSFER",
  IN_KIND_AND_CASH_TRANSFER = "IN_KIND_AND_CASH_TRANSFER",
  IN_KIND_TRANSFER = "IN_KIND_TRANSFER",
  NONE = "NONE",
}

export enum KycStatus {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  L0 = "L0",
  L1 = "L1",
  L2 = "L2",
  MANUAL_REVIEW = "MANUAL_REVIEW",
  NONE = "NONE",
  NOT_PASSED = "NOT_PASSED",
  PASSED = "PASSED",
  PENDING_ACTION = "PENDING_ACTION",
  REVIEW = "REVIEW",
  STEP_UP = "STEP_UP",
  UNARCHIVED = "UNARCHIVED",
  VERIFICATION = "VERIFICATION",
  VERIFICATION_ADDRESS = "VERIFICATION_ADDRESS",
  VERIFICATION_DRIVERS_LICENSE = "VERIFICATION_DRIVERS_LICENSE",
  VERIFICATION_SSN = "VERIFICATION_SSN",
}

export enum MaritalStatus {
  MARRIED = "MARRIED",
  NONE = "NONE",
  SINGLE = "SINGLE",
}

export enum MarketOrderStatus {
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  EXECUTED = "EXECUTED",
  EXECUTING = "EXECUTING",
  FAILED = "FAILED",
  LIQUIDITY_PROVIDER_SELECTED = "LIQUIDITY_PROVIDER_SELECTED",
  NONE = "NONE",
  RETRY = "RETRY",
  WALLET_DEBITED = "WALLET_DEBITED",
}

export enum MarketOrderTrigger {
  CONDITIONAL_TRANSACTION = "CONDITIONAL_TRANSACTION",
  NONE = "NONE",
  RECURRING_PURCHASE = "RECURRING_PURCHASE",
  USER = "USER",
}

export enum MarketingEventType {
  ACCOUNT_WIZARD_COMPLETE = "ACCOUNT_WIZARD_COMPLETE",
  FUNDING_CREATION = "FUNDING_CREATION",
  INITIAL_ACCOUNT_WIZARD_COMPLETE = "INITIAL_ACCOUNT_WIZARD_COMPLETE",
  LOGIN = "LOGIN",
  NONE = "NONE",
  USER_CREATION = "USER_CREATION",
}

export enum NoteStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  NONE = "NONE",
}

export enum NoteType {
  ACCOUNT = "ACCOUNT",
  FUNDING = "FUNDING",
  FUNDING_V2 = "FUNDING_V2",
  NONE = "NONE",
  USER = "USER",
}

export enum NotificationSettingType {
  DOCUMENTS_PENDING_CLIENT = "DOCUMENTS_PENDING_CLIENT",
  FUNDING_CONTRIBUTION_INSTRUCTIONS = "FUNDING_CONTRIBUTION_INSTRUCTIONS",
  FUNDS_RELEASED = "FUNDS_RELEASED",
  IRA_ADOPTION_AGREEMENT = "IRA_ADOPTION_AGREEMENT",
  NONE = "NONE",
  PCA_TREASURY_ACCOUNT_APPROVED = "PCA_TREASURY_ACCOUNT_APPROVED",
  PCA_WIZARD_COMPLETED = "PCA_WIZARD_COMPLETED",
  PENDING_CLIENT_DOCS_REMINDER = "PENDING_CLIENT_DOCS_REMINDER",
  ROLLOVER5_BUS_DAYS = "ROLLOVER5_BUS_DAYS",
  TRANSFER_AND_CASH2_BUS_DAYS = "TRANSFER_AND_CASH2_BUS_DAYS",
  TRANSFER_FORM_FOLLOW_UP = "TRANSFER_FORM_FOLLOW_UP",
  TRANSFER_PENDING = "TRANSFER_PENDING",
  TREASURY_ACCOUNT_APPROVED = "TREASURY_ACCOUNT_APPROVED",
  VERIFICATION = "VERIFICATION",
  VERIFICATION_ADDRESS = "VERIFICATION_ADDRESS",
  VERIFICATION_DRIVERS_LICENSE = "VERIFICATION_DRIVERS_LICENSE",
  VERIFICATION_SSN = "VERIFICATION_SSN",
  WIZARD_COMPLETED = "WIZARD_COMPLETED",
}

export enum NotificationType {
  ALL = "ALL",
  DEVICE_PUSH = "DEVICE_PUSH",
  EMAIL = "EMAIL",
  NONE = "NONE",
  SMS = "SMS",
}

export enum OrderType {
  BUY = "BUY",
  SELL = "SELL",
}

export enum PaymentType {
  ACH = "ACH",
  ACH_DEPOSIT = "ACH_DEPOSIT",
  ACH_DEPOSIT_RETURN = "ACH_DEPOSIT_RETURN",
  ACH_DEPOSIT_REVERSE = "ACH_DEPOSIT_REVERSE",
  ACH_WITHDRAWAL = "ACH_WITHDRAWAL",
  ACH_WITHDRAWAL_RETURN = "ACH_WITHDRAWAL_RETURN",
  ACH_WITHDRAWAL_REVERSE = "ACH_WITHDRAWAL_REVERSE",
  ASSET_DISTRIBUTION = "ASSET_DISTRIBUTION",
  BUY_CRYPTO = "BUY_CRYPTO",
  BUY_PRECIOUS_METAL = "BUY_PRECIOUS_METAL",
  CARD_DEPOSIT = "CARD_DEPOSIT",
  CARD_WITHDRAWAL = "CARD_WITHDRAWAL",
  CASH = "CASH",
  CHECK = "CHECK",
  CHECK_DEPOSIT = "CHECK_DEPOSIT",
  DEBIT = "DEBIT",
  DEPOSIT_CRYPTO = "DEPOSIT_CRYPTO",
  DEPOSIT_PRECIOUS_METAL = "DEPOSIT_PRECIOUS_METAL",
  FORTRESS_EXIT_FEE = "FORTRESS_EXIT_FEE",
  FORTRESS_FEE_REFUND = "FORTRESS_FEE_REFUND",
  INCOMING_ACH_DEPOSIT = "INCOMING_ACH_DEPOSIT",
  INCOMING_ACH_WITHDRAWAL = "INCOMING_ACH_WITHDRAWAL",
  INITIAL_DEPOSIT = "INITIAL_DEPOSIT",
  INTERNAL = "INTERNAL",
  INTERNAL_CRYPTO = "INTERNAL_CRYPTO",
  INTERNATIONAL_WIRE_WITHDRAWAL = "INTERNATIONAL_WIRE_WITHDRAWAL",
  IN_KIND = "IN_KIND",
  LEDGER = "LEDGER",
  MANUALLY_PROCESSED = "MANUALLY_PROCESSED",
  NA = "NA",
  NONE = "NONE",
  NTA_ACH_DEPOSIT = "NTA_ACH_DEPOSIT",
  NTA_ACH_WITHDRAWAL = "NTA_ACH_WITHDRAWAL",
  NTA_CRYPTO_DEPOSIT = "NTA_CRYPTO_DEPOSIT",
  NTA_CRYPTO_WITHDRAWAL = "NTA_CRYPTO_WITHDRAWAL",
  NTA_WIRE_DEPOSIT = "NTA_WIRE_DEPOSIT",
  NTA_WIRE_WITHDRAWAL = "NTA_WIRE_WITHDRAWAL",
  PRIVATE_SECURITY_DEPOSIT = "PRIVATE_SECURITY_DEPOSIT",
  PRIVATE_SECURITY_INTERNAL = "PRIVATE_SECURITY_INTERNAL",
  PRIVATE_SECURITY_WITHDRAWAL = "PRIVATE_SECURITY_WITHDRAWAL",
  RIA_DEPOSIT = "RIA_DEPOSIT",
  RIA_WITHDRAWAL = "RIA_WITHDRAWAL",
  SELL_CRYPTO = "SELL_CRYPTO",
  SELL_PRECIOUS_METAL = "SELL_PRECIOUS_METAL",
  TOKEN_MIGRATION = "TOKEN_MIGRATION",
  TPA_DEPOSIT = "TPA_DEPOSIT",
  TPA_WITHDRAWAL = "TPA_WITHDRAWAL",
  TRANSFER_FEE = "TRANSFER_FEE",
  WIRE = "WIRE",
  WIRE_DEPOSIT = "WIRE_DEPOSIT",
  WIRE_DEPOSIT_PARTIAL_RETURN = "WIRE_DEPOSIT_PARTIAL_RETURN",
  WIRE_DEPOSIT_RETURN = "WIRE_DEPOSIT_RETURN",
  WIRE_DEPOSIT_REVERSE = "WIRE_DEPOSIT_REVERSE",
  WIRE_WITHDRAWAL = "WIRE_WITHDRAWAL",
  WIRE_WITHDRAWAL_RETURN = "WIRE_WITHDRAWAL_RETURN",
  WIRE_WITHDRAWAL_REVERSE = "WIRE_WITHDRAWAL_REVERSE",
  WITHDRAWAL_CRYPTO = "WITHDRAWAL_CRYPTO",
  WITHDRAWAL_PRECIOUS_METAL = "WITHDRAWAL_PRECIOUS_METAL",
}

export enum ProductType {
  IRA = "IRA",
  NONE = "NONE",
  PCA = "PCA",
  TPA = "TPA",
  TREASURY = "TREASURY",
}

export enum RecurringPurchaseHistoryStatus {
  EXECUTED = "EXECUTED",
  EXECUTING = "EXECUTING",
  FAILED = "FAILED",
  NONE = "NONE",
  PENDING = "PENDING",
}

export enum RecurringPurchaseScheduledTrigger {
  FIFTEENTH = "FIFTEENTH",
  FIRST = "FIRST",
  MONDAY = "MONDAY",
  NONE = "NONE",
}

export enum RecurringPurchaseStatus {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  NONE = "NONE",
}

export enum ReferralSource {
  EMAIL = "EMAIL",
  LINK = "LINK",
  NONE = "NONE",
}

export enum RolloverFromType {
  CURRENT_EMPLOYER = "CURRENT_EMPLOYER",
  NONE = "NONE",
  PREVIOUS_EMPLOYER = "PREVIOUS_EMPLOYER",
}

export enum RolloverType {
  CARES_ACT_ROLLOVER = "CARES_ACT_ROLLOVER",
  NONE = "NONE",
  ROLLOVER = "ROLLOVER",
  _60_DAY_ROLLOVER = "_60_DAY_ROLLOVER",
}

export enum SmsStatus {
  CREATED = "CREATED",
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  NONE = "NONE",
  SENT = "SENT",
}

export enum SmsTemplateType {
  ACCOUNT_ACTIVATION = "ACCOUNT_ACTIVATION",
  ACCOUNT_DOCUMENTS_DRAFTED = "ACCOUNT_DOCUMENTS_DRAFTED",
  ASSET_TRANSFER_PENDING = "ASSET_TRANSFER_PENDING",
  DISTRIBUTION_VERIFICATION_REQUIRED = "DISTRIBUTION_VERIFICATION_REQUIRED",
  DOCUMENTS_PENDING = "DOCUMENTS_PENDING",
  DOCUMENTS_SENT_TO_CLIENT = "DOCUMENTS_SENT_TO_CLIENT",
  DOCU_SIGN = "DOCU_SIGN",
  FOLLOW_UP_AFTER_TRANSFER_FORM_SENT_TO_PREVIOUS_CUSTODIAN = "FOLLOW_UP_AFTER_TRANSFER_FORM_SENT_TO_PREVIOUS_CUSTODIAN",
  FUNDING_APPROVED = "FUNDING_APPROVED",
  FUNDING_INSTRUCTIONS_SENT = "FUNDING_INSTRUCTIONS_SENT",
  INACTIVE_ACCOUNT = "INACTIVE_ACCOUNT",
  IRA_ADOPTION_AGREEMENT = "IRA_ADOPTION_AGREEMENT",
  NONE = "NONE",
  NOTIFICATION_OF_EMAIL_ADDRESS = "NOTIFICATION_OF_EMAIL_ADDRESS",
  NOTIFICATION_OF_EMAIL_IRA = "NOTIFICATION_OF_EMAIL_IRA",
  NOTIFICATION_OF_EMAIL_NEW_IRA = "NOTIFICATION_OF_EMAIL_NEW_IRA",
  NOTIFICATION_OF_EMAIL_PHOTO = "NOTIFICATION_OF_EMAIL_PHOTO",
  PCA_WIZARD_COMPLETE = "PCA_WIZARD_COMPLETE",
  RESENT_FUNDING_CASH_CONTRIBUTION = "RESENT_FUNDING_CASH_CONTRIBUTION",
  RESENT_FUNDING_ROLLOVER = "RESENT_FUNDING_ROLLOVER",
  RESENT_FUNDING_TRANSFER_FORM = "RESENT_FUNDING_TRANSFER_FORM",
  SECONDARY_CASH_CONTRIBUTION = "SECONDARY_CASH_CONTRIBUTION",
  TRANSFER_FORM_CONFIRMED_RECEIVED = "TRANSFER_FORM_CONFIRMED_RECEIVED",
  TRANSFER_FORM_FOLLOW_UP = "TRANSFER_FORM_FOLLOW_UP",
  VERIFICATION = "VERIFICATION",
  VERIFICATION_ADDRESS = "VERIFICATION_ADDRESS",
  VERIFICATION_DRIVERS_LICENSE = "VERIFICATION_DRIVERS_LICENSE",
  VERIFICATION_SSN = "VERIFICATION_SSN",
  WIZARD_COMPLETE = "WIZARD_COMPLETE",
}

export enum SortEnumType {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SpousalConsent {
  NO = "NO",
  NONE = "NONE",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  YES = "YES",
}

export enum StakingEnrollmentStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  ENROLLED = "ENROLLED",
  FAILED = "FAILED",
  NONE = "NONE",
  STAKED = "STAKED",
  UNSTAKED = "UNSTAKED",
}

export enum StakingMovementDirection {
  INBOUND = "INBOUND",
  NONE = "NONE",
  OUTBOUND = "OUTBOUND",
  STAKE = "STAKE",
  UNSTAKE = "UNSTAKE",
}

export enum StakingMovementType {
  NONE = "NONE",
  PRINCIPLE = "PRINCIPLE",
  REWARD = "REWARD",
}

export enum StakingSource {
  COINBASE = "COINBASE",
  NONE = "NONE",
}

export enum StakingTermStatus {
  COMPLETE = "COMPLETE",
  ENROLLMENT = "ENROLLMENT",
  NONE = "NONE",
  PENDING = "PENDING",
  PENDING_REWARDS = "PENDING_REWARDS",
  STAKED = "STAKED",
}

export enum SubscriptionBillingFrequency {
  ANNUAL = "ANNUAL",
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  NONE = "NONE",
}

export enum SubscriptionBillingMethod {
  CREDIT_CARD = "CREDIT_CARD",
  NONE = "NONE",
}

export enum SubscriptionBillingStatus {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  DELINQUENT = "DELINQUENT",
  NONE = "NONE",
}

export enum Suffix {
  II = "II",
  III = "III",
  IV = "IV",
  JR = "JR",
  NONE = "NONE",
  SR = "SR",
  V = "V",
  VI = "VI",
}

export enum SystemRole {
  ADMIN = "ADMIN",
  ADMIN_GROUP = "ADMIN_GROUP",
  CRM_GROUP = "CRM_GROUP",
  CRM_WRITE_GROUP = "CRM_WRITE_GROUP",
  CUSTODIAN = "CUSTODIAN",
  CUSTOMER = "CUSTOMER",
  FORTRESS = "FORTRESS",
  FUNCTION = "FUNCTION",
  FUNDING = "FUNDING",
  FUNDING_ADMIN = "FUNDING_ADMIN",
  FUNDING_GROUP = "FUNDING_GROUP",
  GENERAL = "GENERAL",
  I_TRUST_CUSTODIAN = "I_TRUST_CUSTODIAN",
  MARKETING_ADMIN = "MARKETING_ADMIN",
  NONE = "NONE",
  PRIMARY_CRM_WRITE_GROUP = "PRIMARY_CRM_WRITE_GROUP",
  PROCESSING = "PROCESSING",
  PROCESSING_ADMIN = "PROCESSING_ADMIN",
  PROCESSING_T1 = "PROCESSING_T1",
  PRODUCT = "PRODUCT",
  RIA = "RIA",
  SUPER_ADMIN = "SUPER_ADMIN",
  TPA = "TPA",
}

export enum Theme {
  DARK = "DARK",
  LIGHT = "LIGHT",
  MIDNIGHT = "MIDNIGHT",
  NONE = "NONE",
}

export enum TourType {
  DASHBOARD_NEW_UI = "DASHBOARD_NEW_UI",
  NONE = "NONE",
  OPEN_TRANSACTIONS = "OPEN_TRANSACTIONS",
}

export enum TransferType {
  INHERITED_TRANSFER = "INHERITED_TRANSFER",
  NONE = "NONE",
  STANDARD_TRANSFER = "STANDARD_TRANSFER",
}

export enum UserStage {
  ACCOUNT = "ACCOUNT",
  CLOSED = "CLOSED",
  KYC = "KYC",
  NONE = "NONE",
  VERIFIED = "VERIFIED",
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  AUTH_CREATE_USER_FAILED = "AUTH_CREATE_USER_FAILED",
  AUTH_LOGIN = "AUTH_LOGIN",
  AUTH_VERIFY = "AUTH_VERIFY",
  DELETED = "DELETED",
  DISABLED = "DISABLED",
  EMAIL_VERIFY = "EMAIL_VERIFY",
  LEAD = "LEAD",
  NONE = "NONE",
}

export enum WalletUpdateType {
  FUNDING = "FUNDING",
  FUNDING_TRANSACTION = "FUNDING_TRANSACTION",
  MARKET_ORDER = "MARKET_ORDER",
  NONE = "NONE",
  STAKING_MOVEMENT = "STAKING_MOVEMENT",
  YIELD_MOVEMENT = "YIELD_MOVEMENT",
}

export enum YieldEnrollmentStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  EARNING = "EARNING",
  ENROLLED = "ENROLLED",
  ENROLLING = "ENROLLING",
  FAILED = "FAILED",
  IN_REVIEW = "IN_REVIEW",
  NONE = "NONE",
  PENDING = "PENDING",
  UNENROLLED = "UNENROLLED",
  UNENROLLING = "UNENROLLING",
}

export enum YieldMovementDirection {
  INBOUND = "INBOUND",
  NONE = "NONE",
  OUTBOUND = "OUTBOUND",
}

export enum YieldMovementType {
  NONE = "NONE",
  PRINCIPLE = "PRINCIPLE",
  REWARD = "REWARD",
}

export interface AccountFilterInput {
  accountNumber?: StringOperationFilterInput | null;
  accountPurpose?: StringOperationFilterInput | null;
  accountStageHistories?: ListFilterInputTypeOfAccountStageHistoryFilterInput | null;
  activatedAt?: DateTimeOperationFilterInput | null;
  addresses?: ListFilterInputTypeOfUserAddressFilterInput | null;
  and?: AccountFilterInput[] | null;
  beneficiaries?: ListFilterInputTypeOfBeneficiaryFilterInput | null;
  churnReason?: NullableOfChurnReasonOperationFilterInput | null;
  closedAt?: DateTimeOperationFilterInput | null;
  closedByRole?: NullableOfSystemRoleOperationFilterInput | null;
  closedByUserId?: IntOperationFilterInput | null;
  conditionalTransactions?: ListFilterInputTypeOfConditionalTransactionFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  cryptoDepositAddresses?: ListFilterInputTypeOfCryptoDepositAddressFilterInput | null;
  custodian?: CustodianTypeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  displayName?: StringOperationFilterInput | null;
  documents?: ListFilterInputTypeOfDocumentFilterInput | null;
  fortressTransferWizardComplete?: BooleanOperationFilterInput | null;
  fundedAt?: DateTimeOperationFilterInput | null;
  fundingsV2?: ListFilterInputTypeOfFundingV2FilterInput | null;
  id?: IntOperationFilterInput | null;
  inboundFundings?: ListFilterInputTypeOfFundingFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  irsInfos?: ListFilterInputTypeOfIrsInfoFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  kycEvaluations?: ListFilterInputTypeOfKycEvaluationFilterInput | null;
  marketOrders?: ListFilterInputTypeOfMarketOrderFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  needsUpdatedIraAgreement?: BooleanOperationFilterInput | null;
  or?: AccountFilterInput[] | null;
  outboundFundings?: ListFilterInputTypeOfFundingFilterInput | null;
  productType?: ProductTypeOperationFilterInput | null;
  recurringPurchases?: ListFilterInputTypeOfRecurringPurchaseFilterInput | null;
  regeneratedAt?: DateTimeOperationFilterInput | null;
  regeneratedByUserId?: IntOperationFilterInput | null;
  regeneratedReason?: StringOperationFilterInput | null;
  signedUpdatedIraAgreementAt?: DateTimeOperationFilterInput | null;
  signedUpdatedPcaAgreementAt?: DateTimeOperationFilterInput | null;
  sourceOfFunds?: StringOperationFilterInput | null;
  sparkTokenOwned?: DecimalOperationFilterInput | null;
  stage?: AccountStageOperationFilterInput | null;
  stakingEnrollments?: ListFilterInputTypeOfStakingEnrollmentFilterInput | null;
  stakingMovements?: ListFilterInputTypeOfStakingMovementFilterInput | null;
  status?: AccountStatusOperationFilterInput | null;
  subscriptionBillings?: ListFilterInputTypeOfSubscriptionBillingFilterInput | null;
  taxBitId?: StringOperationFilterInput | null;
  taxBitQuestionnaireStatus?: StringOperationFilterInput | null;
  tpaRelationship?: TpaRelationshipFilterInput | null;
  tpaRelationshipId?: IntOperationFilterInput | null;
  tradeFeeCredit?: TradeFeeCreditFilterInput | null;
  treasuryAccount?: TreasuryAccountFilterInput | null;
  type?: AccountTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
  walletHistories?: ListFilterInputTypeOfWalletHistoryFilterInput | null;
  wallets?: ListFilterInputTypeOfWalletFilterInput | null;
  wizardCompletedAt?: DateTimeOperationFilterInput | null;
  yieldEnrollments?: ListFilterInputTypeOfYieldEnrollmentFilterInput | null;
  yieldInvestors?: ListFilterInputTypeOfYieldInvestorFilterInput | null;
  yieldMovements?: ListFilterInputTypeOfYieldMovementFilterInput | null;
}

export interface AccountOrderOperationFilterInput {
  eq?: AccountOrder | null;
  in?: AccountOrder[] | null;
  neq?: AccountOrder | null;
  nin?: AccountOrder[] | null;
}

export interface AccountOrderWrapperFilterInput {
  accountOrder?: AccountOrderOperationFilterInput | null;
  and?: AccountOrderWrapperFilterInput[] | null;
  or?: AccountOrderWrapperFilterInput[] | null;
}

export interface AccountSortInput {
  accountNumber?: SortEnumType | null;
  accountPurpose?: SortEnumType | null;
  activatedAt?: SortEnumType | null;
  churnReason?: SortEnumType | null;
  closedAt?: SortEnumType | null;
  closedByRole?: SortEnumType | null;
  closedByUserId?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  custodian?: SortEnumType | null;
  device?: SortEnumType | null;
  displayName?: SortEnumType | null;
  fortressTransferWizardComplete?: SortEnumType | null;
  fundedAt?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  needsUpdatedIraAgreement?: SortEnumType | null;
  productType?: SortEnumType | null;
  regeneratedAt?: SortEnumType | null;
  regeneratedByUserId?: SortEnumType | null;
  regeneratedReason?: SortEnumType | null;
  signedUpdatedIraAgreementAt?: SortEnumType | null;
  signedUpdatedPcaAgreementAt?: SortEnumType | null;
  sourceOfFunds?: SortEnumType | null;
  sparkTokenOwned?: SortEnumType | null;
  stage?: SortEnumType | null;
  status?: SortEnumType | null;
  taxBitId?: SortEnumType | null;
  taxBitQuestionnaireStatus?: SortEnumType | null;
  tpaRelationship?: TpaRelationshipSortInput | null;
  tpaRelationshipId?: SortEnumType | null;
  tradeFeeCredit?: TradeFeeCreditSortInput | null;
  treasuryAccount?: TreasuryAccountSortInput | null;
  type?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  user?: UserSortInput | null;
  userId?: SortEnumType | null;
  wizardCompletedAt?: SortEnumType | null;
}

export interface AccountStageHistoryFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: AccountStageHistoryFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: AccountStageHistoryFilterInput[] | null;
  stage?: AccountStageOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface AccountStageOperationFilterInput {
  eq?: AccountStage | null;
  in?: AccountStage[] | null;
  neq?: AccountStage | null;
  nin?: AccountStage[] | null;
}

export interface AccountStatusOperationFilterInput {
  eq?: AccountStatus | null;
  in?: AccountStatus[] | null;
  neq?: AccountStatus | null;
  nin?: AccountStatus[] | null;
}

export interface AccountTypeOperationFilterInput {
  eq?: AccountType | null;
  in?: AccountType[] | null;
  neq?: AccountType | null;
  nin?: AccountType[] | null;
}

export interface AddAccountInput {
  custodianId?: number | null;
  displayName?: string | null;
  status?: AccountStatus | null;
  type: AccountType;
  userId?: number | null;
}

export interface AddBeneficiaryAddressInput {
  address?: string | null;
  address2?: string | null;
  city?: string | null;
  country?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface AddBeneficiaryInput {
  accountHolderRelationship?: string | null;
  accountId?: number | null;
  addresses?: (AddBeneficiaryAddressInput | null)[] | null;
  dateOfBirth?: any | null;
  dateOfDeath?: any | null;
  directive?: BeneficiaryDirective | null;
  email?: string | null;
  firstName: string;
  lastName: string;
  middleName?: string | null;
  percentage?: any | null;
  phoneNumber?: string | null;
  relationship?: BeneficiaryRelationshipType | null;
  socialSecurityNumber?: string | null;
  spousalConsent?: SpousalConsent | null;
  spousalConsentFormDocumentId?: number | null;
  type: BeneficiaryType;
  userId?: number | null;
}

export interface AddCrmUserInput {
  email: string;
  firstName: string;
  lastName: string;
  role: SystemRole;
}

export interface AddDocumentFileInput {
  name?: string | null;
  url?: string | null;
}

export interface AddDocumentInput {
  accountId?: number | null;
  displayName?: string | null;
  docuSignStatus?: DocuSignStatus | null;
  docuSignTemplate?: DocuSignTemplateType | null;
  files?: (AddDocumentFileInput | null)[] | null;
  fileTemplate?: FileTemplateType | null;
  fundingId?: number | null;
  fundingV2Id?: number | null;
  name?: string | null;
  stage?: DocumentStage | null;
  type: DocumentType;
  userId?: number | null;
}

export interface AddExternalAccountTempInput {
  accountNumber?: string | null;
  accountType: AccountType;
  institutionAddress?: string | null;
  institutionId?: string | null;
  institutionName?: string | null;
  isPrimary: boolean;
  otherAccountType?: string | null;
  userId?: number | null;
}

export interface AddFundingAssetInput {
  currency: string;
  originalBalance: any;
  paymentType?: PaymentType | null;
  requestedAmount: any;
  transactionHash?: string | null;
  transferEntireBalance?: boolean | null;
}

export interface AddFundingInput {
  associatedFundingId?: number | null;
  beneficiaryId?: number | null;
  contributionType?: ContributionType | null;
  contributionYear?: number | null;
  currency?: string | null;
  direction: FundingDirection;
  distributionCode?: string | null;
  federalWithholdings?: any | null;
  fromAccountId?: number | null;
  fromExternalAccount?: AddExternalAccountTempInput | null;
  fromExternalAccountId?: number | null;
  fundingAssets?: (AddFundingAssetInput | null)[] | null;
  idempotencyId: string;
  isFullTransfer?: boolean | null;
  microTransactionRequested?: boolean | null;
  networkId?: number | null;
  paymentType?: PaymentType | null;
  preventInternalAccount?: boolean | null;
  promoCode?: string | null;
  requestedAmount?: any | null;
  rolloverFrom?: RolloverFromType | null;
  rolloverType?: RolloverType | null;
  signatureBase64?: string | null;
  sourceCryptoAddress?: string | null;
  stateWithholdings?: any | null;
  status?: FundingStatus | null;
  toAccountId?: number | null;
  toExternalAccount?: AddExternalAccountTempInput | null;
  toExternalAccountId?: number | null;
  transactionCode?: string | null;
  transferInstruction?: IraTransferInstruction | null;
  transferringCustodianId?: number | null;
  type: FundingType;
}

export interface AddNoteInput {
  subject: string;
  text: string;
  type: NoteType;
  typeId: number;
}

export interface AddNotificationSettingInput {
  notificationTypes: NotificationType[];
  type: NotificationSettingType;
  userId?: number | null;
}

export interface AddReferralInput {
  referralSource: ReferralSource;
  referredUserId: number;
  sentByUserId: number;
}

export interface AddressTypeOperationFilterInput {
  eq?: AddressType | null;
  in?: AddressType[] | null;
  neq?: AddressType | null;
  nin?: AddressType[] | null;
}

export interface AssignBeneficiaryToAccountInput {
  accountId: number;
  beneficiaryId: number;
  percentage: any;
  type: BeneficiaryType;
}

export interface BeneficiaryAddressFilterInput {
  address?: StringOperationFilterInput | null;
  address2?: StringOperationFilterInput | null;
  and?: BeneficiaryAddressFilterInput[] | null;
  beneficiary?: BeneficiaryFilterInput | null;
  beneficiaryId?: IntOperationFilterInput | null;
  city?: StringOperationFilterInput | null;
  country?: StringOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  fullAddress?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: BeneficiaryAddressFilterInput[] | null;
  state?: StringOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  zipCode?: StringOperationFilterInput | null;
}

export interface BeneficiaryFilterInput {
  account?: AccountFilterInput | null;
  accountHolderRelationship?: StringOperationFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  addresses?: ListFilterInputTypeOfBeneficiaryAddressFilterInput | null;
  and?: BeneficiaryFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  dateOfBirth?: DateTimeOperationFilterInput | null;
  dateOfDeath?: DateTimeOperationFilterInput | null;
  directive?: NullableOfBeneficiaryDirectiveOperationFilterInput | null;
  email?: StringOperationFilterInput | null;
  firstName?: StringOperationFilterInput | null;
  fullName?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  isSpousalConsentRequired?: BooleanOperationFilterInput | null;
  lastName?: StringOperationFilterInput | null;
  middleName?: StringOperationFilterInput | null;
  or?: BeneficiaryFilterInput[] | null;
  percentage?: DecimalOperationFilterInput | null;
  phoneNumber?: StringOperationFilterInput | null;
  relationship?: BeneficiaryRelationshipTypeOperationFilterInput | null;
  socialSecurityNumber?: StringOperationFilterInput | null;
  spousalConsent?: NullableOfSpousalConsentOperationFilterInput | null;
  spousalConsentFormDocumentId?: IntOperationFilterInput | null;
  status?: NullableOfBeneficiaryStatusOperationFilterInput | null;
  type?: NullableOfBeneficiaryTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
  yearOfRetirement?: IntOperationFilterInput | null;
}

export interface BeneficiaryRelationshipTypeOperationFilterInput {
  eq?: BeneficiaryRelationshipType | null;
  in?: BeneficiaryRelationshipType[] | null;
  neq?: BeneficiaryRelationshipType | null;
  nin?: BeneficiaryRelationshipType[] | null;
}

export interface BeneficiarySortInput {
  account?: AccountSortInput | null;
  accountHolderRelationship?: SortEnumType | null;
  accountId?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  dateOfBirth?: SortEnumType | null;
  dateOfDeath?: SortEnumType | null;
  directive?: SortEnumType | null;
  email?: SortEnumType | null;
  firstName?: SortEnumType | null;
  fullName?: SortEnumType | null;
  id?: SortEnumType | null;
  isSpousalConsentRequired?: SortEnumType | null;
  lastName?: SortEnumType | null;
  middleName?: SortEnumType | null;
  percentage?: SortEnumType | null;
  phoneNumber?: SortEnumType | null;
  relationship?: SortEnumType | null;
  socialSecurityNumber?: SortEnumType | null;
  spousalConsent?: SortEnumType | null;
  spousalConsentFormDocumentId?: SortEnumType | null;
  status?: SortEnumType | null;
  type?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  user?: UserSortInput | null;
  userId?: SortEnumType | null;
  yearOfRetirement?: SortEnumType | null;
}

export interface BooleanOperationFilterInput {
  eq?: boolean | null;
  neq?: boolean | null;
}

export interface BusinessTypeOperationFilterInput {
  eq?: BusinessType | null;
  in?: BusinessType[] | null;
  neq?: BusinessType | null;
  nin?: BusinessType[] | null;
}

export interface CancelFundingInput {
  fundingId: number;
}

export interface ClickwrapTemplateFilterInput {
  and?: ClickwrapTemplateFilterInput[] | null;
  id?: IntOperationFilterInput | null;
  or?: ClickwrapTemplateFilterInput[] | null;
  templateGuid?: UuidOperationFilterInput | null;
  type?: DocuSignClickwrapTemplateTypeOperationFilterInput | null;
}

export interface ClickwrapTemplateSortInput {
  id?: SortEnumType | null;
  templateGuid?: SortEnumType | null;
  type?: SortEnumType | null;
}

export interface CloseAccountInput {
  accountId: number;
  churnReason: ChurnReason;
  isInactive?: boolean | null;
  note?: string | null;
}

export interface CompleteFundingV2Input {
  id: number;
}

export interface ConditionalTransactionFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: ConditionalTransactionFilterInput[] | null;
  attempts?: IntOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  failureReason?: StringOperationFilterInput | null;
  fromAmount?: DecimalOperationFilterInput | null;
  fromAmountExecuted?: DecimalOperationFilterInput | null;
  fromCurrencyV2?: CurrencyV2FilterInput | null;
  fromCurrencyV2Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  marketOrders?: ListFilterInputTypeOfMarketOrderFilterInput | null;
  or?: ConditionalTransactionFilterInput[] | null;
  orderType?: OrderTypeOperationFilterInput | null;
  quotePrice?: DecimalOperationFilterInput | null;
  status?: ConditionalTransactionStatusOperationFilterInput | null;
  toCurrencyV2?: CurrencyV2FilterInput | null;
  toCurrencyV2Id?: IntOperationFilterInput | null;
  triggeredPrice?: DecimalOperationFilterInput | null;
  triggerPoint?: ConditionalTransactionTriggerPointOperationFilterInput | null;
  triggerPrice?: DecimalOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface ConditionalTransactionSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  attempts?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  failureReason?: SortEnumType | null;
  fromAmount?: SortEnumType | null;
  fromAmountExecuted?: SortEnumType | null;
  fromCurrencyV2?: CurrencyV2SortInput | null;
  fromCurrencyV2Id?: SortEnumType | null;
  id?: SortEnumType | null;
  orderType?: SortEnumType | null;
  quotePrice?: SortEnumType | null;
  status?: SortEnumType | null;
  toCurrencyV2?: CurrencyV2SortInput | null;
  toCurrencyV2Id?: SortEnumType | null;
  triggeredPrice?: SortEnumType | null;
  triggerPoint?: SortEnumType | null;
  triggerPrice?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface ConditionalTransactionStatusOperationFilterInput {
  eq?: ConditionalTransactionStatus | null;
  in?: ConditionalTransactionStatus[] | null;
  neq?: ConditionalTransactionStatus | null;
  nin?: ConditionalTransactionStatus[] | null;
}

export interface ConditionalTransactionTriggerPointOperationFilterInput {
  eq?: ConditionalTransactionTriggerPoint | null;
  in?: ConditionalTransactionTriggerPoint[] | null;
  neq?: ConditionalTransactionTriggerPoint | null;
  nin?: ConditionalTransactionTriggerPoint[] | null;
}

export interface CreditTradeFeeCreditsInput {
  accountIds: number[];
  amount: any;
  reason: string;
}

export interface CrmUserFilterInput {
  and?: CrmUserFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  crmUserLoginHistories?: ListFilterInputTypeOfCrmUserLoginHistoryFilterInput | null;
  device?: StringOperationFilterInput | null;
  email?: StringOperationFilterInput | null;
  firstName?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  lastName?: StringOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  notes?: ListFilterInputTypeOfNoteFilterInput | null;
  or?: CrmUserFilterInput[] | null;
  passwordChangedOn?: DateTimeOperationFilterInput | null;
  role?: SystemRoleOperationFilterInput | null;
  smsMessages?: ListFilterInputTypeOfSmsMessageFilterInput | null;
  status?: CrmUserStatusOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface CrmUserLoginHistoryFilterInput {
  and?: CrmUserLoginHistoryFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  crmUser?: CrmUserFilterInput | null;
  crmUserId?: IntOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: CrmUserLoginHistoryFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface CrmUserSortInput {
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  email?: SortEnumType | null;
  firstName?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  lastName?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  passwordChangedOn?: SortEnumType | null;
  role?: SortEnumType | null;
  status?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface CrmUserStatusOperationFilterInput {
  eq?: CrmUserStatus | null;
  in?: CrmUserStatus[] | null;
  neq?: CrmUserStatus | null;
  nin?: CrmUserStatus[] | null;
}

export interface CryptoDepositAddressFilterInput {
  account?: AccountFilterInput | null;
  and?: CryptoDepositAddressFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  id?: IntOperationFilterInput | null;
  network?: NetworkFilterInput | null;
  networkId?: IntOperationFilterInput | null;
  or?: CryptoDepositAddressFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface CurrencyFeatureOperationFilterInput {
  eq?: CurrencyFeature | null;
  in?: CurrencyFeature[] | null;
  neq?: CurrencyFeature | null;
  nin?: CurrencyFeature[] | null;
}

export interface CurrencyFeatureWrapperFilterInput {
  and?: CurrencyFeatureWrapperFilterInput[] | null;
  feature?: CurrencyFeatureOperationFilterInput | null;
  or?: CurrencyFeatureWrapperFilterInput[] | null;
}

export interface CurrencyNetworkFilterInput {
  and?: CurrencyNetworkFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  enabled?: BooleanOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  network?: NetworkFilterInput | null;
  networkId?: IntOperationFilterInput | null;
  or?: CurrencyNetworkFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface CurrencyV2FilterInput {
  and?: CurrencyV2FilterInput[] | null;
  assetClass?: StringOperationFilterInput | null;
  categoriesV2?: ListStringOperationFilterInput | null;
  currencyNetworks?: ListFilterInputTypeOfCurrencyNetworkFilterInput | null;
  displayEnabled?: BooleanOperationFilterInput | null;
  displayEnabledForTesting?: BooleanOperationFilterInput | null;
  featuresEnabled?: ListFilterInputTypeOfCurrencyFeatureWrapperFilterInput | null;
  id?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: CurrencyV2FilterInput[] | null;
  quotingEnabled?: BooleanOperationFilterInput | null;
  subtitle?: StringOperationFilterInput | null;
  ticker?: StringOperationFilterInput | null;
}

export interface CurrencyV2SortInput {
  id?: SortEnumType | null;
  marketCap?: SortEnumType | null;
  name?: SortEnumType | null;
  quotingEnabled?: SortEnumType | null;
  subtitle?: SortEnumType | null;
  ticker?: SortEnumType | null;
}

export interface CustodianAccountFilterInput {
  account?: AccountFilterInput | null;
  accountCustodian?: CustodianFilterInput | null;
  accountCustodianId?: IntOperationFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: CustodianAccountFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  custodian?: NullableOfCustodianTypeOperationFilterInput | null;
  custodianAccountId?: StringOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: CustodianAccountFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface CustodianAccountTypeWrapperFilterInput {
  and?: CustodianAccountTypeWrapperFilterInput[] | null;
  or?: CustodianAccountTypeWrapperFilterInput[] | null;
  type?: StringOperationFilterInput | null;
}

export interface CustodianFilterInput {
  and?: CustodianFilterInput[] | null;
  custodianType?: CustodianTypeOperationFilterInput | null;
  displayName?: StringOperationFilterInput | null;
  enabledProductTypes?: ListFilterInputTypeOfProductTypeWrapperFilterInput | null;
  id?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: CustodianFilterInput[] | null;
  supportedAccountTypes?: ListFilterInputTypeOfCustodianAccountTypeWrapperFilterInput | null;
  supportsMetals?: BooleanOperationFilterInput | null;
  tpaRelationships?: ListFilterInputTypeOfTpaRelationshipFilterInput | null;
}

export interface CustodianSortInput {
  custodianType?: SortEnumType | null;
  displayName?: SortEnumType | null;
  id?: SortEnumType | null;
  name?: SortEnumType | null;
  supportsMetals?: SortEnumType | null;
}

export interface CustodianTypeOperationFilterInput {
  eq?: CustodianType | null;
  in?: CustodianType[] | null;
  neq?: CustodianType | null;
  nin?: CustodianType[] | null;
}

export interface DateTimeOperationFilterInput {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: (any | null)[] | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: (any | null)[] | null;
  nlt?: any | null;
  nlte?: any | null;
}

export interface DebitTradeFeeCreditsInput {
  accountIds: number[];
  amount: any;
  reason: string;
}

export interface DecimalOperationFilterInput {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: (any | null)[] | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: (any | null)[] | null;
  nlt?: any | null;
  nlte?: any | null;
}

export interface DeclineFundingInput {
  fundingId: number;
}

export interface DeleteBeneficiaryInput {
  id: number;
}

export interface DocuSignClickwrapTemplateTypeOperationFilterInput {
  eq?: DocuSignClickwrapTemplateType | null;
  in?: DocuSignClickwrapTemplateType[] | null;
  neq?: DocuSignClickwrapTemplateType | null;
  nin?: DocuSignClickwrapTemplateType[] | null;
}

export interface DocumentFileFilterInput {
  and?: DocumentFileFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  document?: DocumentFilterInput | null;
  documentId?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: DocumentFileFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  url?: StringOperationFilterInput | null;
}

export interface DocumentFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  agreedOn?: DateTimeOperationFilterInput | null;
  agreementId?: UuidOperationFilterInput | null;
  alloyId?: StringOperationFilterInput | null;
  and?: DocumentFilterInput[] | null;
  approvedAt?: DateTimeOperationFilterInput | null;
  clickwrapTemplate?: ClickwrapTemplateFilterInput | null;
  clickwrapTemplateId?: IntOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  custodianSignedAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  displayName?: StringOperationFilterInput | null;
  docuSignClickwrapTemplate?: NullableOfDocuSignClickwrapTemplateTypeOperationFilterInput | null;
  docuSignDocumentId?: UuidOperationFilterInput | null;
  docuSignId?: StringOperationFilterInput | null;
  docuSignTemplate?: NullableOfDocuSignTemplateTypeOperationFilterInput | null;
  externalToken?: StringOperationFilterInput | null;
  externalType?: StringOperationFilterInput | null;
  files?: ListFilterInputTypeOfDocumentFileFilterInput | null;
  fileTemplate?: NullableOfFileTemplateTypeOperationFilterInput | null;
  funding?: FundingFilterInput | null;
  fundingId?: IntOperationFilterInput | null;
  fundingV2?: FundingV2FilterInput | null;
  fundingV2Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: DocumentFilterInput[] | null;
  sentAt?: DateTimeOperationFilterInput | null;
  signedAt?: DateTimeOperationFilterInput | null;
  stage?: DocumentStageOperationFilterInput | null;
  status?: DocumentStatusOperationFilterInput | null;
  type?: DocumentTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
  version?: StringOperationFilterInput | null;
  versionId?: UuidOperationFilterInput | null;
  voidedAt?: DateTimeOperationFilterInput | null;
}

export interface DocumentSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  agreedOn?: SortEnumType | null;
  agreementId?: SortEnumType | null;
  alloyId?: SortEnumType | null;
  approvedAt?: SortEnumType | null;
  clickwrapTemplate?: ClickwrapTemplateSortInput | null;
  clickwrapTemplateId?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  custodianSignedAt?: SortEnumType | null;
  device?: SortEnumType | null;
  displayName?: SortEnumType | null;
  docuSignClickwrapTemplate?: SortEnumType | null;
  docuSignDocumentId?: SortEnumType | null;
  docuSignId?: SortEnumType | null;
  docuSignTemplate?: SortEnumType | null;
  externalToken?: SortEnumType | null;
  externalType?: SortEnumType | null;
  fileTemplate?: SortEnumType | null;
  funding?: FundingSortInput | null;
  fundingId?: SortEnumType | null;
  fundingV2?: FundingV2SortInput | null;
  fundingV2Id?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  name?: SortEnumType | null;
  sentAt?: SortEnumType | null;
  signedAt?: SortEnumType | null;
  stage?: SortEnumType | null;
  status?: SortEnumType | null;
  type?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  user?: UserSortInput | null;
  userId?: SortEnumType | null;
  version?: SortEnumType | null;
  versionId?: SortEnumType | null;
  voidedAt?: SortEnumType | null;
}

export interface DocumentStageOperationFilterInput {
  eq?: DocumentStage | null;
  in?: DocumentStage[] | null;
  neq?: DocumentStage | null;
  nin?: DocumentStage[] | null;
}

export interface DocumentStatusOperationFilterInput {
  eq?: DocumentStatus | null;
  in?: DocumentStatus[] | null;
  neq?: DocumentStatus | null;
  nin?: DocumentStatus[] | null;
}

export interface DocumentTypeOperationFilterInput {
  eq?: DocumentType | null;
  in?: DocumentType[] | null;
  neq?: DocumentType | null;
  nin?: DocumentType[] | null;
}

export interface EmailAddressInput {
  address: string;
  type: EmailAddressType;
}

export interface EmailAddressTypeOperationFilterInput {
  eq?: EmailAddressType | null;
  in?: EmailAddressType[] | null;
  neq?: EmailAddressType | null;
  nin?: EmailAddressType[] | null;
}

export interface EmailDeliveryStatusFilterInput {
  and?: EmailDeliveryStatusFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  deliveredDate?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  email?: EmailFilterInput | null;
  emailAddress?: StringOperationFilterInput | null;
  emailAddressType?: EmailAddressTypeOperationFilterInput | null;
  emailId?: IntOperationFilterInput | null;
  failedDate?: DateTimeOperationFilterInput | null;
  failureReason?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: EmailDeliveryStatusFilterInput[] | null;
  sentDate?: DateTimeOperationFilterInput | null;
  status?: EmailStatusOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface EmailDeliveryStatusSortInput {
  createdAt?: SortEnumType | null;
  deliveredDate?: SortEnumType | null;
  device?: SortEnumType | null;
  email?: EmailSortInput | null;
  emailAddress?: SortEnumType | null;
  emailAddressType?: SortEnumType | null;
  emailId?: SortEnumType | null;
  failedDate?: SortEnumType | null;
  failureReason?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  sentDate?: SortEnumType | null;
  status?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface EmailFilterInput {
  accountId?: IntOperationFilterInput | null;
  and?: EmailFilterInput[] | null;
  body?: StringOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  emailDeliveryStatuses?: ListFilterInputTypeOfEmailDeliveryStatusFilterInput | null;
  from?: StringOperationFilterInput | null;
  fundingId?: IntOperationFilterInput | null;
  fundingV2Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  idempotencyId?: StringOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: EmailFilterInput[] | null;
  sentByRole?: NullableOfSystemRoleOperationFilterInput | null;
  sentByUserId?: IntOperationFilterInput | null;
  subject?: StringOperationFilterInput | null;
  template?: EmailTemplateTypeOperationFilterInput | null;
  templateId?: StringOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface EmailSortInput {
  accountId?: SortEnumType | null;
  body?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  from?: SortEnumType | null;
  fundingId?: SortEnumType | null;
  fundingV2Id?: SortEnumType | null;
  id?: SortEnumType | null;
  idempotencyId?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  sentByRole?: SortEnumType | null;
  sentByUserId?: SortEnumType | null;
  subject?: SortEnumType | null;
  template?: SortEnumType | null;
  templateId?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  userId?: SortEnumType | null;
}

export interface EmailStatusOperationFilterInput {
  eq?: EmailStatus | null;
  in?: EmailStatus[] | null;
  neq?: EmailStatus | null;
  nin?: EmailStatus[] | null;
}

export interface EmailTemplateTypeOperationFilterInput {
  eq?: EmailTemplateType | null;
  in?: EmailTemplateType[] | null;
  neq?: EmailTemplateType | null;
  nin?: EmailTemplateType[] | null;
}

export interface ExternalAccountFilterInput {
  accountNumber?: StringOperationFilterInput | null;
  accountType?: AccountTypeOperationFilterInput | null;
  and?: ExternalAccountFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  fundingTransactions?: ListFilterInputTypeOfFundingTransactionFilterInput | null;
  id?: IntOperationFilterInput | null;
  inboundFundings?: ListFilterInputTypeOfFundingFilterInput | null;
  institutionAddress?: StringOperationFilterInput | null;
  institutionId?: StringOperationFilterInput | null;
  institutionName?: StringOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  isDeleted?: BooleanOperationFilterInput | null;
  isPrimary?: BooleanOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: ExternalAccountFilterInput[] | null;
  otherAccountType?: StringOperationFilterInput | null;
  outboundFundings?: ListFilterInputTypeOfFundingFilterInput | null;
  plaidAccountId?: StringOperationFilterInput | null;
  transferringCustodian?: TransferringCustodianFilterInput | null;
  transferringCustodianId?: IntOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface ExternalAccountSortInput {
  accountNumber?: SortEnumType | null;
  accountType?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  id?: SortEnumType | null;
  institutionAddress?: SortEnumType | null;
  institutionId?: SortEnumType | null;
  institutionName?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  isDeleted?: SortEnumType | null;
  isPrimary?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  otherAccountType?: SortEnumType | null;
  plaidAccountId?: SortEnumType | null;
  transferringCustodian?: TransferringCustodianSortInput | null;
  transferringCustodianId?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  user?: UserSortInput | null;
  userId?: SortEnumType | null;
}

export interface FileTemplateTypeOperationFilterInput {
  eq?: FileTemplateType | null;
  in?: FileTemplateType[] | null;
  neq?: FileTemplateType | null;
  nin?: FileTemplateType[] | null;
}

export interface FileUrlWrapperFilterInput {
  and?: FileUrlWrapperFilterInput[] | null;
  fileUrl?: StringOperationFilterInput | null;
  or?: FileUrlWrapperFilterInput[] | null;
}

export interface FundingAssetFilterInput {
  amount?: DecimalOperationFilterInput | null;
  and?: FundingAssetFilterInput[] | null;
  blockHeight?: LongOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  fairMarketValue?: DecimalOperationFilterInput | null;
  fairMarketValueTimeStamp?: DateTimeOperationFilterInput | null;
  funding?: FundingFilterInput | null;
  fundingId?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: FundingAssetFilterInput[] | null;
  originalBalance?: DecimalOperationFilterInput | null;
  paymentType?: NullableOfPaymentTypeOperationFilterInput | null;
  requestedAmount?: DecimalOperationFilterInput | null;
  salesForceOpportunityId?: StringOperationFilterInput | null;
  status?: FundingStatusOperationFilterInput | null;
  transactionHash?: StringOperationFilterInput | null;
  transferEntireBalance?: BooleanOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface FundingAssetSortInput {
  amount?: SortEnumType | null;
  blockHeight?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  currency?: CurrencyV2SortInput | null;
  currencyId?: SortEnumType | null;
  fairMarketValue?: SortEnumType | null;
  fairMarketValueTimeStamp?: SortEnumType | null;
  funding?: FundingSortInput | null;
  fundingId?: SortEnumType | null;
  id?: SortEnumType | null;
  originalBalance?: SortEnumType | null;
  paymentType?: SortEnumType | null;
  requestedAmount?: SortEnumType | null;
  salesForceOpportunityId?: SortEnumType | null;
  status?: SortEnumType | null;
  transactionHash?: SortEnumType | null;
  transferEntireBalance?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface FundingDirectionOperationFilterInput {
  eq?: FundingDirection | null;
  in?: FundingDirection[] | null;
  neq?: FundingDirection | null;
  nin?: FundingDirection[] | null;
}

export interface FundingFilterInput {
  amount?: DecimalOperationFilterInput | null;
  and?: FundingFilterInput[] | null;
  associatedFunding?: FundingFilterInput | null;
  associatedFundingId?: IntOperationFilterInput | null;
  beneficiary?: BeneficiaryFilterInput | null;
  beneficiaryId?: IntOperationFilterInput | null;
  canceledAt?: DateTimeOperationFilterInput | null;
  contributionType?: NullableOfContributionTypeOperationFilterInput | null;
  contributionYear?: IntOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  custodian?: NullableOfCustodianTypeOperationFilterInput | null;
  declinedAt?: DateTimeOperationFilterInput | null;
  destinationCryptoAddress?: StringOperationFilterInput | null;
  destinationCryptoAddressTag?: StringOperationFilterInput | null;
  direction?: FundingDirectionOperationFilterInput | null;
  distributedToClient?: DecimalOperationFilterInput | null;
  distributedTotalAmount?: DecimalOperationFilterInput | null;
  distributionCode?: StringOperationFilterInput | null;
  documentFileUploadedAt?: DateTimeOperationFilterInput | null;
  documents?: ListFilterInputTypeOfDocumentFilterInput | null;
  fairMarketValue?: DecimalOperationFilterInput | null;
  fairMarketValueTimeStamp?: DateTimeOperationFilterInput | null;
  federalWithholdings?: DecimalOperationFilterInput | null;
  federalWithholdingsTransactionId?: StringOperationFilterInput | null;
  fromAccount?: AccountFilterInput | null;
  fromAccountId?: IntOperationFilterInput | null;
  fromExternalAccount?: ExternalAccountFilterInput | null;
  fromExternalAccountId?: IntOperationFilterInput | null;
  fundedAt?: DateTimeOperationFilterInput | null;
  fundingAssets?: ListFilterInputTypeOfFundingAssetFilterInput | null;
  fundingStageHistories?: ListFilterInputTypeOfFundingStageHistoryFilterInput | null;
  fundingV2?: FundingV2FilterInput | null;
  fundingV2Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  iraTransferInstruction?: NullableOfIraTransferInstructionOperationFilterInput | null;
  isFullTransfer?: BooleanOperationFilterInput | null;
  isInitialFunding?: BooleanOperationFilterInput | null;
  marketingEvent?: ListFilterInputTypeOfMarketingEventFilterInput | null;
  microTestAmount?: DecimalOperationFilterInput | null;
  microTestAmountConfirmed?: BooleanOperationFilterInput | null;
  microTestTransactionDate?: DateTimeOperationFilterInput | null;
  microTestTransactionId?: StringOperationFilterInput | null;
  microTransactionRequested?: BooleanOperationFilterInput | null;
  network?: NetworkFilterInput | null;
  networkId?: IntOperationFilterInput | null;
  or?: FundingFilterInput[] | null;
  originalBalance?: DecimalOperationFilterInput | null;
  paymentId?: StringOperationFilterInput | null;
  paymentType?: PaymentTypeOperationFilterInput | null;
  promo?: PromoFilterInput | null;
  promoId?: IntOperationFilterInput | null;
  requestedAmount?: DecimalOperationFilterInput | null;
  rolloverFrom?: NullableOfRolloverFromTypeOperationFilterInput | null;
  rolloverType?: NullableOfRolloverTypeOperationFilterInput | null;
  signatureBase64?: StringOperationFilterInput | null;
  sourceCryptoAddress?: StringOperationFilterInput | null;
  stage?: FundingStageOperationFilterInput | null;
  stateWithholdings?: DecimalOperationFilterInput | null;
  stateWithholdingsTransactionId?: StringOperationFilterInput | null;
  status?: FundingStatusOperationFilterInput | null;
  ticker?: StringOperationFilterInput | null;
  toAccount?: AccountFilterInput | null;
  toAccountId?: IntOperationFilterInput | null;
  toExternalAccount?: ExternalAccountFilterInput | null;
  toExternalAccountId?: IntOperationFilterInput | null;
  transactionCode?: StringOperationFilterInput | null;
  transactionDate?: DateTimeOperationFilterInput | null;
  transactionId?: StringOperationFilterInput | null;
  transactionStatus?: StringOperationFilterInput | null;
  type?: FundingTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface FundingSortInput {
  amount?: SortEnumType | null;
  associatedFunding?: FundingSortInput | null;
  associatedFundingId?: SortEnumType | null;
  beneficiary?: BeneficiarySortInput | null;
  beneficiaryId?: SortEnumType | null;
  canceledAt?: SortEnumType | null;
  contributionType?: SortEnumType | null;
  contributionYear?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  custodian?: SortEnumType | null;
  declinedAt?: SortEnumType | null;
  destinationCryptoAddress?: SortEnumType | null;
  destinationCryptoAddressTag?: SortEnumType | null;
  direction?: SortEnumType | null;
  distributedToClient?: SortEnumType | null;
  distributedTotalAmount?: SortEnumType | null;
  distributionCode?: SortEnumType | null;
  documentFileUploadedAt?: SortEnumType | null;
  fairMarketValue?: SortEnumType | null;
  fairMarketValueTimeStamp?: SortEnumType | null;
  federalWithholdings?: SortEnumType | null;
  federalWithholdingsTransactionId?: SortEnumType | null;
  fromAccount?: AccountSortInput | null;
  fromAccountId?: SortEnumType | null;
  fromExternalAccount?: ExternalAccountSortInput | null;
  fromExternalAccountId?: SortEnumType | null;
  fundedAt?: SortEnumType | null;
  fundingV2?: FundingV2SortInput | null;
  fundingV2Id?: SortEnumType | null;
  id?: SortEnumType | null;
  iraTransferInstruction?: SortEnumType | null;
  isFullTransfer?: SortEnumType | null;
  isInitialFunding?: SortEnumType | null;
  microTestAmount?: SortEnumType | null;
  microTestAmountConfirmed?: SortEnumType | null;
  microTestTransactionDate?: SortEnumType | null;
  microTestTransactionId?: SortEnumType | null;
  microTransactionRequested?: SortEnumType | null;
  network?: NetworkSortInput | null;
  networkId?: SortEnumType | null;
  originalBalance?: SortEnumType | null;
  paymentId?: SortEnumType | null;
  paymentType?: SortEnumType | null;
  promo?: PromoSortInput | null;
  promoId?: SortEnumType | null;
  requestedAmount?: SortEnumType | null;
  rolloverFrom?: SortEnumType | null;
  rolloverType?: SortEnumType | null;
  signatureBase64?: SortEnumType | null;
  sourceCryptoAddress?: SortEnumType | null;
  stage?: SortEnumType | null;
  stateWithholdings?: SortEnumType | null;
  stateWithholdingsTransactionId?: SortEnumType | null;
  status?: SortEnumType | null;
  ticker?: SortEnumType | null;
  toAccount?: AccountSortInput | null;
  toAccountId?: SortEnumType | null;
  toExternalAccount?: ExternalAccountSortInput | null;
  toExternalAccountId?: SortEnumType | null;
  transactionCode?: SortEnumType | null;
  transactionDate?: SortEnumType | null;
  transactionId?: SortEnumType | null;
  transactionStatus?: SortEnumType | null;
  type?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface FundingStageHistoryFilterInput {
  and?: FundingStageHistoryFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  funding?: FundingFilterInput | null;
  fundingId?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: FundingStageHistoryFilterInput[] | null;
  stage?: FundingStageOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface FundingStageOperationFilterInput {
  eq?: FundingStage | null;
  in?: FundingStage[] | null;
  neq?: FundingStage | null;
  nin?: FundingStage[] | null;
}

export interface FundingStatusOperationFilterInput {
  eq?: FundingStatus | null;
  in?: FundingStatus[] | null;
  neq?: FundingStatus | null;
  nin?: FundingStatus[] | null;
}

export interface FundingTransactionFilterInput {
  amount?: DecimalOperationFilterInput | null;
  and?: FundingTransactionFilterInput[] | null;
  blockHeight?: LongOperationFilterInput | null;
  canceledAt?: DateTimeOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  declinedAt?: DateTimeOperationFilterInput | null;
  destinationCryptoAddress?: StringOperationFilterInput | null;
  destinationCryptoAddressTag?: StringOperationFilterInput | null;
  direction?: FundingDirectionOperationFilterInput | null;
  externalAccount?: ExternalAccountFilterInput | null;
  externalAccountId?: IntOperationFilterInput | null;
  externalTransactionDate?: DateTimeOperationFilterInput | null;
  externalTransactionId?: StringOperationFilterInput | null;
  fromAccount?: AccountFilterInput | null;
  fromAccountId?: IntOperationFilterInput | null;
  fundedAt?: DateTimeOperationFilterInput | null;
  funding?: FundingV2FilterInput | null;
  fundingAssetId?: IntOperationFilterInput | null;
  fundingId?: IntOperationFilterInput | null;
  fundingTransactionStatusHistories?: ListFilterInputTypeOfFundingTransactionStatusHistoryFilterInput | null;
  id?: IntOperationFilterInput | null;
  microTestConfirmed?: BooleanOperationFilterInput | null;
  microTransactionRequested?: BooleanOperationFilterInput | null;
  network?: NetworkFilterInput | null;
  networkId?: IntOperationFilterInput | null;
  or?: FundingTransactionFilterInput[] | null;
  originalBalance?: DecimalOperationFilterInput | null;
  paymentId?: StringOperationFilterInput | null;
  paymentType?: NullableOfPaymentTypeOperationFilterInput | null;
  processedAt?: DateTimeOperationFilterInput | null;
  requestedAmount?: DecimalOperationFilterInput | null;
  sourceCryptoAddress?: StringOperationFilterInput | null;
  status?: FundingTransactionStatusOperationFilterInput | null;
  toAccount?: AccountFilterInput | null;
  toAccountId?: IntOperationFilterInput | null;
  transactionCode?: StringOperationFilterInput | null;
  transactionHash?: StringOperationFilterInput | null;
  transactionStatus?: StringOperationFilterInput | null;
  transferEntireBalance?: BooleanOperationFilterInput | null;
  type?: FundingTransactionTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  usdValue?: DecimalOperationFilterInput | null;
  usdValueTimeStamp?: DateTimeOperationFilterInput | null;
}

export interface FundingTransactionStatusHistoryFilterInput {
  and?: FundingTransactionStatusHistoryFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  fundingTransaction?: FundingTransactionFilterInput | null;
  fundingTransactionId?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: FundingTransactionStatusHistoryFilterInput[] | null;
  status?: FundingTransactionStatusOperationFilterInput | null;
}

export interface FundingTransactionStatusOperationFilterInput {
  eq?: FundingTransactionStatus | null;
  in?: FundingTransactionStatus[] | null;
  neq?: FundingTransactionStatus | null;
  nin?: FundingTransactionStatus[] | null;
}

export interface FundingTransactionTypeOperationFilterInput {
  eq?: FundingTransactionType | null;
  in?: FundingTransactionType[] | null;
  neq?: FundingTransactionType | null;
  nin?: FundingTransactionType[] | null;
}

export interface FundingTypeOperationFilterInput {
  eq?: FundingType | null;
  in?: FundingType[] | null;
  neq?: FundingType | null;
  nin?: FundingType[] | null;
}

export interface FundingTypeWrapperFilterInput {
  and?: FundingTypeWrapperFilterInput[] | null;
  fundingType?: FundingTypeOperationFilterInput | null;
  or?: FundingTypeWrapperFilterInput[] | null;
}

export interface FundingV2FilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: FundingV2FilterInput[] | null;
  associatedFundingV1Id?: IntOperationFilterInput | null;
  associatedFundingV2?: FundingV2FilterInput | null;
  associatedFundingV2Id?: IntOperationFilterInput | null;
  beneficiary?: BeneficiaryFilterInput | null;
  beneficiaryId?: IntOperationFilterInput | null;
  completedAt?: DateTimeOperationFilterInput | null;
  contributionType?: NullableOfContributionTypeOperationFilterInput | null;
  contributionYear?: IntOperationFilterInput | null;
  correctedAt?: DateTimeOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  custodian?: NullableOfCustodianTypeOperationFilterInput | null;
  direction?: FundingDirectionOperationFilterInput | null;
  distributionCode?: StringOperationFilterInput | null;
  documentFileUploadedAt?: DateTimeOperationFilterInput | null;
  documents?: ListFilterInputTypeOfDocumentFilterInput | null;
  estimatedUsdValue?: DecimalOperationFilterInput | null;
  fundingV1?: FundingFilterInput | null;
  fundingV1Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  iraTransferInstruction?: NullableOfIraTransferInstructionOperationFilterInput | null;
  isFullTransfer?: BooleanOperationFilterInput | null;
  isInitialFunding?: BooleanOperationFilterInput | null;
  marketingEvents?: ListFilterInputTypeOfMarketingEventFilterInput | null;
  or?: FundingV2FilterInput[] | null;
  paidConversionFee?: BooleanOperationFilterInput | null;
  promo?: PromoFilterInput | null;
  promoId?: IntOperationFilterInput | null;
  rolloverFrom?: NullableOfRolloverFromTypeOperationFilterInput | null;
  rolloverType?: NullableOfRolloverTypeOperationFilterInput | null;
  salesForceOpportunityId?: StringOperationFilterInput | null;
  signatureBase64?: StringOperationFilterInput | null;
  status?: NullableOfFundingStatusOperationFilterInput | null;
  transactions?: ListFilterInputTypeOfFundingTransactionFilterInput | null;
  transferType?: NullableOfTransferTypeOperationFilterInput | null;
  type?: FundingV2TypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  usdValue?: DecimalOperationFilterInput | null;
}

export interface FundingV2SortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  associatedFundingV1Id?: SortEnumType | null;
  associatedFundingV2?: FundingV2SortInput | null;
  associatedFundingV2Id?: SortEnumType | null;
  beneficiary?: BeneficiarySortInput | null;
  beneficiaryId?: SortEnumType | null;
  completedAt?: SortEnumType | null;
  contributionType?: SortEnumType | null;
  contributionYear?: SortEnumType | null;
  correctedAt?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  custodian?: SortEnumType | null;
  direction?: SortEnumType | null;
  distributionCode?: SortEnumType | null;
  documentFileUploadedAt?: SortEnumType | null;
  estimatedUsdValue?: SortEnumType | null;
  fundingV1?: FundingSortInput | null;
  fundingV1Id?: SortEnumType | null;
  id?: SortEnumType | null;
  iraTransferInstruction?: SortEnumType | null;
  isFullTransfer?: SortEnumType | null;
  isInitialFunding?: SortEnumType | null;
  paidConversionFee?: SortEnumType | null;
  promo?: PromoSortInput | null;
  promoId?: SortEnumType | null;
  rolloverFrom?: SortEnumType | null;
  rolloverType?: SortEnumType | null;
  salesForceOpportunityId?: SortEnumType | null;
  signatureBase64?: SortEnumType | null;
  status?: SortEnumType | null;
  transferType?: SortEnumType | null;
  type?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  usdValue?: SortEnumType | null;
}

export interface FundingV2TypeOperationFilterInput {
  eq?: FundingV2Type | null;
  in?: FundingV2Type[] | null;
  neq?: FundingV2Type | null;
  nin?: FundingV2Type[] | null;
}

export interface FundingV2TypeWrapperFilterInput {
  and?: FundingV2TypeWrapperFilterInput[] | null;
  fundingV2Type?: FundingV2TypeOperationFilterInput | null;
  or?: FundingV2TypeWrapperFilterInput[] | null;
}

export interface GenerateDepositInstructionsInput {
  accountId: number;
  type: FundingInstructionType;
}

export interface GenerateDocumentPreviewUrlInput {
  documentFileId: number;
  returnUrl: string;
}

export interface GenerateDocumentSignerUrlInput {
  id: number;
  returnUrl: string;
}

export interface GenerateDocumentUploadTokenInput {
  extension?: string | null;
  fileName?: string | null;
  template: FileTemplateType;
  type: DocumentType;
  userId?: number | null;
}

export interface GenerateFundingsReportInput {
  createdFrom: any;
  createdTo: any;
}

export interface GenerateServicePinInput {
  userId: number;
}

export interface GetAccountHistoriesInput {
  accountId: number;
}

export interface GetDailyStakingEnrollmentsInput {
  date: any;
}

export interface GetEmailTemplateInput {
  accountId?: number | null;
  templateType: EmailTemplateType;
  userId: number;
}

export interface GetFundingHistoriesInput {
  fundingId: number;
}

export interface GetFundingsInput {
  maxAmount?: any | null;
  minAmount?: any | null;
}

export interface GetUserHistoriesInput {
  userId: number;
}

export interface IdentificationFilterInput {
  and?: IdentificationFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  fileTemplate?: FileTemplateTypeOperationFilterInput | null;
  fileUrls?: ListFilterInputTypeOfFileUrlWrapperFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: IdentificationFilterInput[] | null;
  reviewedAt?: DateTimeOperationFilterInput | null;
  status?: IdentificationStatusOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface IdentificationSortInput {
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  fileTemplate?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  name?: SortEnumType | null;
  reviewedAt?: SortEnumType | null;
  status?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  user?: UserSortInput | null;
  userId?: SortEnumType | null;
}

export interface IdentificationStatusOperationFilterInput {
  eq?: IdentificationStatus | null;
  in?: IdentificationStatus[] | null;
  neq?: IdentificationStatus | null;
  nin?: IdentificationStatus[] | null;
}

export interface IntOperationFilterInput {
  eq?: number | null;
  gt?: number | null;
  gte?: number | null;
  in?: (number | null)[] | null;
  lt?: number | null;
  lte?: number | null;
  neq?: number | null;
  ngt?: number | null;
  ngte?: number | null;
  nin?: (number | null)[] | null;
  nlt?: number | null;
  nlte?: number | null;
}

export interface InvestorFilterInput {
  and?: InvestorFilterInput[] | null;
  id?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: InvestorFilterInput[] | null;
  type?: StringOperationFilterInput | null;
}

export interface IrsInfoFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: IrsInfoFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  lifeExpectancyValue?: DecimalOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: IrsInfoFilterInput[] | null;
  requiredMinimumDistribution?: DecimalOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  year?: IntOperationFilterInput | null;
}

export interface KycEvaluationFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  alloyId?: StringOperationFilterInput | null;
  and?: KycEvaluationFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: KycEvaluationFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  upgradeRequirements?: StringOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface KycStatusOperationFilterInput {
  eq?: KycStatus | null;
  in?: KycStatus[] | null;
  neq?: KycStatus | null;
  nin?: KycStatus[] | null;
}

export interface ListFilterInputTypeOfAccountFilterInput {
  all?: AccountFilterInput | null;
  any?: boolean | null;
  none?: AccountFilterInput | null;
  some?: AccountFilterInput | null;
}

export interface ListFilterInputTypeOfAccountOrderWrapperFilterInput {
  all?: AccountOrderWrapperFilterInput | null;
  any?: boolean | null;
  none?: AccountOrderWrapperFilterInput | null;
  some?: AccountOrderWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfAccountStageHistoryFilterInput {
  all?: AccountStageHistoryFilterInput | null;
  any?: boolean | null;
  none?: AccountStageHistoryFilterInput | null;
  some?: AccountStageHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfBeneficiaryAddressFilterInput {
  all?: BeneficiaryAddressFilterInput | null;
  any?: boolean | null;
  none?: BeneficiaryAddressFilterInput | null;
  some?: BeneficiaryAddressFilterInput | null;
}

export interface ListFilterInputTypeOfBeneficiaryFilterInput {
  all?: BeneficiaryFilterInput | null;
  any?: boolean | null;
  none?: BeneficiaryFilterInput | null;
  some?: BeneficiaryFilterInput | null;
}

export interface ListFilterInputTypeOfConditionalTransactionFilterInput {
  all?: ConditionalTransactionFilterInput | null;
  any?: boolean | null;
  none?: ConditionalTransactionFilterInput | null;
  some?: ConditionalTransactionFilterInput | null;
}

export interface ListFilterInputTypeOfCrmUserLoginHistoryFilterInput {
  all?: CrmUserLoginHistoryFilterInput | null;
  any?: boolean | null;
  none?: CrmUserLoginHistoryFilterInput | null;
  some?: CrmUserLoginHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfCryptoDepositAddressFilterInput {
  all?: CryptoDepositAddressFilterInput | null;
  any?: boolean | null;
  none?: CryptoDepositAddressFilterInput | null;
  some?: CryptoDepositAddressFilterInput | null;
}

export interface ListFilterInputTypeOfCurrencyFeatureWrapperFilterInput {
  all?: CurrencyFeatureWrapperFilterInput | null;
  any?: boolean | null;
  none?: CurrencyFeatureWrapperFilterInput | null;
  some?: CurrencyFeatureWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfCurrencyNetworkFilterInput {
  all?: CurrencyNetworkFilterInput | null;
  any?: boolean | null;
  none?: CurrencyNetworkFilterInput | null;
  some?: CurrencyNetworkFilterInput | null;
}

export interface ListFilterInputTypeOfCustodianAccountFilterInput {
  all?: CustodianAccountFilterInput | null;
  any?: boolean | null;
  none?: CustodianAccountFilterInput | null;
  some?: CustodianAccountFilterInput | null;
}

export interface ListFilterInputTypeOfCustodianAccountTypeWrapperFilterInput {
  all?: CustodianAccountTypeWrapperFilterInput | null;
  any?: boolean | null;
  none?: CustodianAccountTypeWrapperFilterInput | null;
  some?: CustodianAccountTypeWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfDocumentFileFilterInput {
  all?: DocumentFileFilterInput | null;
  any?: boolean | null;
  none?: DocumentFileFilterInput | null;
  some?: DocumentFileFilterInput | null;
}

export interface ListFilterInputTypeOfDocumentFilterInput {
  all?: DocumentFilterInput | null;
  any?: boolean | null;
  none?: DocumentFilterInput | null;
  some?: DocumentFilterInput | null;
}

export interface ListFilterInputTypeOfEmailDeliveryStatusFilterInput {
  all?: EmailDeliveryStatusFilterInput | null;
  any?: boolean | null;
  none?: EmailDeliveryStatusFilterInput | null;
  some?: EmailDeliveryStatusFilterInput | null;
}

export interface ListFilterInputTypeOfExternalAccountFilterInput {
  all?: ExternalAccountFilterInput | null;
  any?: boolean | null;
  none?: ExternalAccountFilterInput | null;
  some?: ExternalAccountFilterInput | null;
}

export interface ListFilterInputTypeOfFileUrlWrapperFilterInput {
  all?: FileUrlWrapperFilterInput | null;
  any?: boolean | null;
  none?: FileUrlWrapperFilterInput | null;
  some?: FileUrlWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfFundingAssetFilterInput {
  all?: FundingAssetFilterInput | null;
  any?: boolean | null;
  none?: FundingAssetFilterInput | null;
  some?: FundingAssetFilterInput | null;
}

export interface ListFilterInputTypeOfFundingFilterInput {
  all?: FundingFilterInput | null;
  any?: boolean | null;
  none?: FundingFilterInput | null;
  some?: FundingFilterInput | null;
}

export interface ListFilterInputTypeOfFundingStageHistoryFilterInput {
  all?: FundingStageHistoryFilterInput | null;
  any?: boolean | null;
  none?: FundingStageHistoryFilterInput | null;
  some?: FundingStageHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfFundingTransactionFilterInput {
  all?: FundingTransactionFilterInput | null;
  any?: boolean | null;
  none?: FundingTransactionFilterInput | null;
  some?: FundingTransactionFilterInput | null;
}

export interface ListFilterInputTypeOfFundingTransactionStatusHistoryFilterInput {
  all?: FundingTransactionStatusHistoryFilterInput | null;
  any?: boolean | null;
  none?: FundingTransactionStatusHistoryFilterInput | null;
  some?: FundingTransactionStatusHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfFundingTypeWrapperFilterInput {
  all?: FundingTypeWrapperFilterInput | null;
  any?: boolean | null;
  none?: FundingTypeWrapperFilterInput | null;
  some?: FundingTypeWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfFundingV2FilterInput {
  all?: FundingV2FilterInput | null;
  any?: boolean | null;
  none?: FundingV2FilterInput | null;
  some?: FundingV2FilterInput | null;
}

export interface ListFilterInputTypeOfFundingV2TypeWrapperFilterInput {
  all?: FundingV2TypeWrapperFilterInput | null;
  any?: boolean | null;
  none?: FundingV2TypeWrapperFilterInput | null;
  some?: FundingV2TypeWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfIrsInfoFilterInput {
  all?: IrsInfoFilterInput | null;
  any?: boolean | null;
  none?: IrsInfoFilterInput | null;
  some?: IrsInfoFilterInput | null;
}

export interface ListFilterInputTypeOfKycEvaluationFilterInput {
  all?: KycEvaluationFilterInput | null;
  any?: boolean | null;
  none?: KycEvaluationFilterInput | null;
  some?: KycEvaluationFilterInput | null;
}

export interface ListFilterInputTypeOfMarketOrderFilterInput {
  all?: MarketOrderFilterInput | null;
  any?: boolean | null;
  none?: MarketOrderFilterInput | null;
  some?: MarketOrderFilterInput | null;
}

export interface ListFilterInputTypeOfMarketingEventFilterInput {
  all?: MarketingEventFilterInput | null;
  any?: boolean | null;
  none?: MarketingEventFilterInput | null;
  some?: MarketingEventFilterInput | null;
}

export interface ListFilterInputTypeOfNoteFilterInput {
  all?: NoteFilterInput | null;
  any?: boolean | null;
  none?: NoteFilterInput | null;
  some?: NoteFilterInput | null;
}

export interface ListFilterInputTypeOfNotificationSettingFilterInput {
  all?: NotificationSettingFilterInput | null;
  any?: boolean | null;
  none?: NotificationSettingFilterInput | null;
  some?: NotificationSettingFilterInput | null;
}

export interface ListFilterInputTypeOfProductTypeWrapperFilterInput {
  all?: ProductTypeWrapperFilterInput | null;
  any?: boolean | null;
  none?: ProductTypeWrapperFilterInput | null;
  some?: ProductTypeWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfRecurringPurchaseFilterInput {
  all?: RecurringPurchaseFilterInput | null;
  any?: boolean | null;
  none?: RecurringPurchaseFilterInput | null;
  some?: RecurringPurchaseFilterInput | null;
}

export interface ListFilterInputTypeOfRecurringPurchaseHistoryFilterInput {
  all?: RecurringPurchaseHistoryFilterInput | null;
  any?: boolean | null;
  none?: RecurringPurchaseHistoryFilterInput | null;
  some?: RecurringPurchaseHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfReferralFilterInput {
  all?: ReferralFilterInput | null;
  any?: boolean | null;
  none?: ReferralFilterInput | null;
  some?: ReferralFilterInput | null;
}

export interface ListFilterInputTypeOfRiaRelationshipFilterInput {
  all?: RiaRelationshipFilterInput | null;
  any?: boolean | null;
  none?: RiaRelationshipFilterInput | null;
  some?: RiaRelationshipFilterInput | null;
}

export interface ListFilterInputTypeOfSecurityAnswerFilterInput {
  all?: SecurityAnswerFilterInput | null;
  any?: boolean | null;
  none?: SecurityAnswerFilterInput | null;
  some?: SecurityAnswerFilterInput | null;
}

export interface ListFilterInputTypeOfSmsMessageFilterInput {
  all?: SmsMessageFilterInput | null;
  any?: boolean | null;
  none?: SmsMessageFilterInput | null;
  some?: SmsMessageFilterInput | null;
}

export interface ListFilterInputTypeOfStakingEnrollmentFilterInput {
  all?: StakingEnrollmentFilterInput | null;
  any?: boolean | null;
  none?: StakingEnrollmentFilterInput | null;
  some?: StakingEnrollmentFilterInput | null;
}

export interface ListFilterInputTypeOfStakingMovementFilterInput {
  all?: StakingMovementFilterInput | null;
  any?: boolean | null;
  none?: StakingMovementFilterInput | null;
  some?: StakingMovementFilterInput | null;
}

export interface ListFilterInputTypeOfSubscriptionBillingChargeFilterInput {
  all?: SubscriptionBillingChargeFilterInput | null;
  any?: boolean | null;
  none?: SubscriptionBillingChargeFilterInput | null;
  some?: SubscriptionBillingChargeFilterInput | null;
}

export interface ListFilterInputTypeOfSubscriptionBillingFilterInput {
  all?: SubscriptionBillingFilterInput | null;
  any?: boolean | null;
  none?: SubscriptionBillingFilterInput | null;
  some?: SubscriptionBillingFilterInput | null;
}

export interface ListFilterInputTypeOfTourTypeWrapperFilterInput {
  all?: TourTypeWrapperFilterInput | null;
  any?: boolean | null;
  none?: TourTypeWrapperFilterInput | null;
  some?: TourTypeWrapperFilterInput | null;
}

export interface ListFilterInputTypeOfTpaRelationshipFilterInput {
  all?: TpaRelationshipFilterInput | null;
  any?: boolean | null;
  none?: TpaRelationshipFilterInput | null;
  some?: TpaRelationshipFilterInput | null;
}

export interface ListFilterInputTypeOfTradeFeeCreditHistoryFilterInput {
  all?: TradeFeeCreditHistoryFilterInput | null;
  any?: boolean | null;
  none?: TradeFeeCreditHistoryFilterInput | null;
  some?: TradeFeeCreditHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfUserAddressFilterInput {
  all?: UserAddressFilterInput | null;
  any?: boolean | null;
  none?: UserAddressFilterInput | null;
  some?: UserAddressFilterInput | null;
}

export interface ListFilterInputTypeOfUserFilterInput {
  all?: UserFilterInput | null;
  any?: boolean | null;
  none?: UserFilterInput | null;
  some?: UserFilterInput | null;
}

export interface ListFilterInputTypeOfUserStageHistoryFilterInput {
  all?: UserStageHistoryFilterInput | null;
  any?: boolean | null;
  none?: UserStageHistoryFilterInput | null;
  some?: UserStageHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfWalletFilterInput {
  all?: WalletFilterInput | null;
  any?: boolean | null;
  none?: WalletFilterInput | null;
  some?: WalletFilterInput | null;
}

export interface ListFilterInputTypeOfWalletHistoryFilterInput {
  all?: WalletHistoryFilterInput | null;
  any?: boolean | null;
  none?: WalletHistoryFilterInput | null;
  some?: WalletHistoryFilterInput | null;
}

export interface ListFilterInputTypeOfWatchCurrencyFilterInput {
  all?: WatchCurrencyFilterInput | null;
  any?: boolean | null;
  none?: WatchCurrencyFilterInput | null;
  some?: WatchCurrencyFilterInput | null;
}

export interface ListFilterInputTypeOfYieldEnrollmentFilterInput {
  all?: YieldEnrollmentFilterInput | null;
  any?: boolean | null;
  none?: YieldEnrollmentFilterInput | null;
  some?: YieldEnrollmentFilterInput | null;
}

export interface ListFilterInputTypeOfYieldInvestorFilterInput {
  all?: YieldInvestorFilterInput | null;
  any?: boolean | null;
  none?: YieldInvestorFilterInput | null;
  some?: YieldInvestorFilterInput | null;
}

export interface ListFilterInputTypeOfYieldMovementFilterInput {
  all?: YieldMovementFilterInput | null;
  any?: boolean | null;
  none?: YieldMovementFilterInput | null;
  some?: YieldMovementFilterInput | null;
}

export interface ListFilterInputTypeOfYieldProductFilterInput {
  all?: YieldProductFilterInput | null;
  any?: boolean | null;
  none?: YieldProductFilterInput | null;
  some?: YieldProductFilterInput | null;
}

export interface ListStringOperationFilterInput {
  all?: StringOperationFilterInput | null;
  any?: boolean | null;
  none?: StringOperationFilterInput | null;
  some?: StringOperationFilterInput | null;
}

export interface LongOperationFilterInput {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: (any | null)[] | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: (any | null)[] | null;
  nlt?: any | null;
  nlte?: any | null;
}

export interface MarketOrderFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: MarketOrderFilterInput[] | null;
  conditionalTransaction?: ConditionalTransactionFilterInput | null;
  conditionalTransactionId?: IntOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  displayAmount?: DecimalOperationFilterInput | null;
  displayFee?: DecimalOperationFilterInput | null;
  displayFeeCredit?: DecimalOperationFilterInput | null;
  displayQuantity?: DecimalOperationFilterInput | null;
  displayTotal?: DecimalOperationFilterInput | null;
  displayUnitPrice?: DecimalOperationFilterInput | null;
  executedAt?: DateTimeOperationFilterInput | null;
  failedAt?: DateTimeOperationFilterInput | null;
  failureReason?: StringOperationFilterInput | null;
  feeAmount?: DecimalOperationFilterInput | null;
  feeBasisPoints?: IntOperationFilterInput | null;
  feeCredit?: DecimalOperationFilterInput | null;
  feeInitialAmount?: DecimalOperationFilterInput | null;
  feeStatus?: StringOperationFilterInput | null;
  feeTransactionId?: UuidOperationFilterInput | null;
  fromAmountExecuted?: DecimalOperationFilterInput | null;
  fromAmountInput?: DecimalOperationFilterInput | null;
  fromCurrencyV2?: CurrencyV2FilterInput | null;
  fromCurrencyV2Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  kitcoSettlementTransactionId?: UuidOperationFilterInput | null;
  kitcoSettlementTransactionStatus?: StringOperationFilterInput | null;
  kitcoTransactionId?: UuidOperationFilterInput | null;
  kitcoTransactionStatus?: StringOperationFilterInput | null;
  or?: MarketOrderFilterInput[] | null;
  orderType?: OrderTypeOperationFilterInput | null;
  quotePrice?: DecimalOperationFilterInput | null;
  recurringPurchaseHistory?: RecurringPurchaseHistoryFilterInput | null;
  recurringPurchaseHistoryId?: IntOperationFilterInput | null;
  status?: MarketOrderStatusOperationFilterInput | null;
  toAmountExecuted?: DecimalOperationFilterInput | null;
  toAmountOutput?: DecimalOperationFilterInput | null;
  toCurrencyV2?: CurrencyV2FilterInput | null;
  toCurrencyV2Id?: IntOperationFilterInput | null;
  trigger?: MarketOrderTriggerOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface MarketOrderSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  conditionalTransaction?: ConditionalTransactionSortInput | null;
  conditionalTransactionId?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  displayAmount?: SortEnumType | null;
  displayFee?: SortEnumType | null;
  displayFeeCredit?: SortEnumType | null;
  displayQuantity?: SortEnumType | null;
  displayTotal?: SortEnumType | null;
  displayUnitPrice?: SortEnumType | null;
  executedAt?: SortEnumType | null;
  failedAt?: SortEnumType | null;
  failureReason?: SortEnumType | null;
  feeAmount?: SortEnumType | null;
  feeBasisPoints?: SortEnumType | null;
  feeCredit?: SortEnumType | null;
  feeInitialAmount?: SortEnumType | null;
  feeStatus?: SortEnumType | null;
  feeTransactionId?: SortEnumType | null;
  fromAmountExecuted?: SortEnumType | null;
  fromAmountInput?: SortEnumType | null;
  fromCurrencyV2?: CurrencyV2SortInput | null;
  fromCurrencyV2Id?: SortEnumType | null;
  id?: SortEnumType | null;
  kitcoSettlementTransactionId?: SortEnumType | null;
  kitcoSettlementTransactionStatus?: SortEnumType | null;
  kitcoTransactionId?: SortEnumType | null;
  kitcoTransactionStatus?: SortEnumType | null;
  orderType?: SortEnumType | null;
  quotePrice?: SortEnumType | null;
  recurringPurchaseHistory?: RecurringPurchaseHistorySortInput | null;
  recurringPurchaseHistoryId?: SortEnumType | null;
  status?: SortEnumType | null;
  toAmountExecuted?: SortEnumType | null;
  toAmountOutput?: SortEnumType | null;
  toCurrencyV2?: CurrencyV2SortInput | null;
  toCurrencyV2Id?: SortEnumType | null;
  trigger?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface MarketOrderStatusOperationFilterInput {
  eq?: MarketOrderStatus | null;
  in?: MarketOrderStatus[] | null;
  neq?: MarketOrderStatus | null;
  nin?: MarketOrderStatus[] | null;
}

export interface MarketOrderTriggerOperationFilterInput {
  eq?: MarketOrderTrigger | null;
  in?: MarketOrderTrigger[] | null;
  neq?: MarketOrderTrigger | null;
  nin?: MarketOrderTrigger[] | null;
}

export interface MarketingAttributeFilterInput {
  affiliateId?: StringOperationFilterInput | null;
  and?: MarketingAttributeFilterInput[] | null;
  campaign?: StringOperationFilterInput | null;
  cjAffiliateId?: StringOperationFilterInput | null;
  content?: StringOperationFilterInput | null;
  everflowTransactionId?: StringOperationFilterInput | null;
  googleClickId?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  medium?: StringOperationFilterInput | null;
  offerId?: StringOperationFilterInput | null;
  or?: MarketingAttributeFilterInput[] | null;
  promoCode?: StringOperationFilterInput | null;
  referralClicks?: IntOperationFilterInput | null;
  referralId?: StringOperationFilterInput | null;
  source?: StringOperationFilterInput | null;
  term?: StringOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface MarketingAttributeSortInput {
  affiliateId?: SortEnumType | null;
  campaign?: SortEnumType | null;
  cjAffiliateId?: SortEnumType | null;
  content?: SortEnumType | null;
  everflowTransactionId?: SortEnumType | null;
  googleClickId?: SortEnumType | null;
  id?: SortEnumType | null;
  medium?: SortEnumType | null;
  offerId?: SortEnumType | null;
  promoCode?: SortEnumType | null;
  referralClicks?: SortEnumType | null;
  referralId?: SortEnumType | null;
  source?: SortEnumType | null;
  term?: SortEnumType | null;
  user?: UserSortInput | null;
  userId?: SortEnumType | null;
}

export interface MarketingEventFilterInput {
  and?: MarketingEventFilterInput[] | null;
  campaign?: StringOperationFilterInput | null;
  content?: StringOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  funding?: FundingFilterInput | null;
  fundingId?: IntOperationFilterInput | null;
  fundingV2?: FundingV2FilterInput | null;
  fundingV2Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  marketingEventType?: MarketingEventTypeOperationFilterInput | null;
  medium?: StringOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: MarketingEventFilterInput[] | null;
  promo?: PromoFilterInput | null;
  promoId?: IntOperationFilterInput | null;
  source?: StringOperationFilterInput | null;
  term?: StringOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface MarketingEventTypeOperationFilterInput {
  eq?: MarketingEventType | null;
  in?: MarketingEventType[] | null;
  neq?: MarketingEventType | null;
  nin?: MarketingEventType[] | null;
}

export interface NetworkFilterInput {
  and?: NetworkFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  logoUrl?: StringOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: NetworkFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface NetworkSortInput {
  createdAt?: SortEnumType | null;
  id?: SortEnumType | null;
  logoUrl?: SortEnumType | null;
  name?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface NoteFilterInput {
  and?: NoteFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  createdByUser?: CrmUserFilterInput | null;
  createdByUserId?: IntOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: NoteFilterInput[] | null;
  status?: NoteStatusOperationFilterInput | null;
  subject?: StringOperationFilterInput | null;
  text?: StringOperationFilterInput | null;
  type?: NoteTypeOperationFilterInput | null;
  typeId?: IntOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface NoteSortInput {
  createdAt?: SortEnumType | null;
  createdByUser?: CrmUserSortInput | null;
  createdByUserId?: SortEnumType | null;
  device?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  status?: SortEnumType | null;
  subject?: SortEnumType | null;
  text?: SortEnumType | null;
  type?: SortEnumType | null;
  typeId?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface NoteStatusOperationFilterInput {
  eq?: NoteStatus | null;
  in?: NoteStatus[] | null;
  neq?: NoteStatus | null;
  nin?: NoteStatus[] | null;
}

export interface NoteTypeOperationFilterInput {
  eq?: NoteType | null;
  in?: NoteType[] | null;
  neq?: NoteType | null;
  nin?: NoteType[] | null;
}

export interface NotificationSettingFilterInput {
  and?: NotificationSettingFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  notificationType?: NotificationTypeOperationFilterInput | null;
  or?: NotificationSettingFilterInput[] | null;
  type?: NotificationSettingTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface NotificationSettingTypeOperationFilterInput {
  eq?: NotificationSettingType | null;
  in?: NotificationSettingType[] | null;
  neq?: NotificationSettingType | null;
  nin?: NotificationSettingType[] | null;
}

export interface NotificationTypeOperationFilterInput {
  eq?: NotificationType | null;
  in?: NotificationType[] | null;
  neq?: NotificationType | null;
  nin?: NotificationType[] | null;
}

export interface NullableOfBeneficiaryDirectiveOperationFilterInput {
  eq?: BeneficiaryDirective | null;
  in?: (BeneficiaryDirective | null)[] | null;
  neq?: BeneficiaryDirective | null;
  nin?: (BeneficiaryDirective | null)[] | null;
}

export interface NullableOfBeneficiaryStatusOperationFilterInput {
  eq?: BeneficiaryStatus | null;
  in?: (BeneficiaryStatus | null)[] | null;
  neq?: BeneficiaryStatus | null;
  nin?: (BeneficiaryStatus | null)[] | null;
}

export interface NullableOfBeneficiaryTypeOperationFilterInput {
  eq?: BeneficiaryType | null;
  in?: (BeneficiaryType | null)[] | null;
  neq?: BeneficiaryType | null;
  nin?: (BeneficiaryType | null)[] | null;
}

export interface NullableOfChurnReasonOperationFilterInput {
  eq?: ChurnReason | null;
  in?: (ChurnReason | null)[] | null;
  neq?: ChurnReason | null;
  nin?: (ChurnReason | null)[] | null;
}

export interface NullableOfContributionTypeOperationFilterInput {
  eq?: ContributionType | null;
  in?: (ContributionType | null)[] | null;
  neq?: ContributionType | null;
  nin?: (ContributionType | null)[] | null;
}

export interface NullableOfCustodianTypeOperationFilterInput {
  eq?: CustodianType | null;
  in?: (CustodianType | null)[] | null;
  neq?: CustodianType | null;
  nin?: (CustodianType | null)[] | null;
}

export interface NullableOfDocuSignClickwrapTemplateTypeOperationFilterInput {
  eq?: DocuSignClickwrapTemplateType | null;
  in?: (DocuSignClickwrapTemplateType | null)[] | null;
  neq?: DocuSignClickwrapTemplateType | null;
  nin?: (DocuSignClickwrapTemplateType | null)[] | null;
}

export interface NullableOfDocuSignTemplateTypeOperationFilterInput {
  eq?: DocuSignTemplateType | null;
  in?: (DocuSignTemplateType | null)[] | null;
  neq?: DocuSignTemplateType | null;
  nin?: (DocuSignTemplateType | null)[] | null;
}

export interface NullableOfEmploymentStatusOperationFilterInput {
  eq?: EmploymentStatus | null;
  in?: (EmploymentStatus | null)[] | null;
  neq?: EmploymentStatus | null;
  nin?: (EmploymentStatus | null)[] | null;
}

export interface NullableOfFileTemplateTypeOperationFilterInput {
  eq?: FileTemplateType | null;
  in?: (FileTemplateType | null)[] | null;
  neq?: FileTemplateType | null;
  nin?: (FileTemplateType | null)[] | null;
}

export interface NullableOfFundingStatusOperationFilterInput {
  eq?: FundingStatus | null;
  in?: (FundingStatus | null)[] | null;
  neq?: FundingStatus | null;
  nin?: (FundingStatus | null)[] | null;
}

export interface NullableOfIraTransferInstructionOperationFilterInput {
  eq?: IraTransferInstruction | null;
  in?: (IraTransferInstruction | null)[] | null;
  neq?: IraTransferInstruction | null;
  nin?: (IraTransferInstruction | null)[] | null;
}

export interface NullableOfMaritalStatusOperationFilterInput {
  eq?: MaritalStatus | null;
  in?: (MaritalStatus | null)[] | null;
  neq?: MaritalStatus | null;
  nin?: (MaritalStatus | null)[] | null;
}

export interface NullableOfPaymentTypeOperationFilterInput {
  eq?: PaymentType | null;
  in?: (PaymentType | null)[] | null;
  neq?: PaymentType | null;
  nin?: (PaymentType | null)[] | null;
}

export interface NullableOfReferralSourceOperationFilterInput {
  eq?: ReferralSource | null;
  in?: (ReferralSource | null)[] | null;
  neq?: ReferralSource | null;
  nin?: (ReferralSource | null)[] | null;
}

export interface NullableOfRolloverFromTypeOperationFilterInput {
  eq?: RolloverFromType | null;
  in?: (RolloverFromType | null)[] | null;
  neq?: RolloverFromType | null;
  nin?: (RolloverFromType | null)[] | null;
}

export interface NullableOfRolloverTypeOperationFilterInput {
  eq?: RolloverType | null;
  in?: (RolloverType | null)[] | null;
  neq?: RolloverType | null;
  nin?: (RolloverType | null)[] | null;
}

export interface NullableOfSpousalConsentOperationFilterInput {
  eq?: SpousalConsent | null;
  in?: (SpousalConsent | null)[] | null;
  neq?: SpousalConsent | null;
  nin?: (SpousalConsent | null)[] | null;
}

export interface NullableOfSuffixOperationFilterInput {
  eq?: Suffix | null;
  in?: (Suffix | null)[] | null;
  neq?: Suffix | null;
  nin?: (Suffix | null)[] | null;
}

export interface NullableOfSystemRoleOperationFilterInput {
  eq?: SystemRole | null;
  in?: (SystemRole | null)[] | null;
  neq?: SystemRole | null;
  nin?: (SystemRole | null)[] | null;
}

export interface NullableOfTransferTypeOperationFilterInput {
  eq?: TransferType | null;
  in?: (TransferType | null)[] | null;
  neq?: TransferType | null;
  nin?: (TransferType | null)[] | null;
}

export interface NullableOfWalletUpdateTypeOperationFilterInput {
  eq?: WalletUpdateType | null;
  in?: (WalletUpdateType | null)[] | null;
  neq?: WalletUpdateType | null;
  nin?: (WalletUpdateType | null)[] | null;
}

export interface OrderTypeOperationFilterInput {
  eq?: OrderType | null;
  in?: OrderType[] | null;
  neq?: OrderType | null;
  nin?: OrderType[] | null;
}

export interface PaymentTypeOperationFilterInput {
  eq?: PaymentType | null;
  in?: PaymentType[] | null;
  neq?: PaymentType | null;
  nin?: PaymentType[] | null;
}

export interface ProductTypeOperationFilterInput {
  eq?: ProductType | null;
  in?: ProductType[] | null;
  neq?: ProductType | null;
  nin?: ProductType[] | null;
}

export interface ProductTypeWrapperFilterInput {
  and?: ProductTypeWrapperFilterInput[] | null;
  or?: ProductTypeWrapperFilterInput[] | null;
  productType?: ProductTypeOperationFilterInput | null;
}

export interface PromoFilterInput {
  and?: PromoFilterInput[] | null;
  code?: StringOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  eligibleFundingTypes?: ListFilterInputTypeOfFundingTypeWrapperFilterInput | null;
  eligibleFundingV2Types?: ListFilterInputTypeOfFundingV2TypeWrapperFilterInput | null;
  endDate?: DateTimeOperationFilterInput | null;
  fundings?: ListFilterInputTypeOfFundingFilterInput | null;
  fundingsV2?: ListFilterInputTypeOfFundingV2FilterInput | null;
  id?: IntOperationFilterInput | null;
  incentive?: StringOperationFilterInput | null;
  isDeleted?: BooleanOperationFilterInput | null;
  marketingEvents?: ListFilterInputTypeOfMarketingEventFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: PromoFilterInput[] | null;
  startDate?: DateTimeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface PromoSortInput {
  code?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  endDate?: SortEnumType | null;
  id?: SortEnumType | null;
  incentive?: SortEnumType | null;
  isDeleted?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  name?: SortEnumType | null;
  startDate?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface RecurringPurchaseFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  amount?: DecimalOperationFilterInput | null;
  and?: RecurringPurchaseFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currencyV2?: CurrencyV2FilterInput | null;
  currencyV2Id?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: RecurringPurchaseFilterInput[] | null;
  recurringPurchaseHistories?: ListFilterInputTypeOfRecurringPurchaseHistoryFilterInput | null;
  scheduledTrigger?: RecurringPurchaseScheduledTriggerOperationFilterInput | null;
  status?: RecurringPurchaseStatusOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface RecurringPurchaseHistoryFilterInput {
  and?: RecurringPurchaseHistoryFilterInput[] | null;
  attempts?: IntOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  failureReason?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  marketOrders?: ListFilterInputTypeOfMarketOrderFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: RecurringPurchaseHistoryFilterInput[] | null;
  recurringPurchase?: RecurringPurchaseFilterInput | null;
  recurringPurchaseId?: IntOperationFilterInput | null;
  status?: RecurringPurchaseHistoryStatusOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface RecurringPurchaseHistorySortInput {
  attempts?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  failureReason?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  recurringPurchase?: RecurringPurchaseSortInput | null;
  recurringPurchaseId?: SortEnumType | null;
  status?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface RecurringPurchaseHistoryStatusOperationFilterInput {
  eq?: RecurringPurchaseHistoryStatus | null;
  in?: RecurringPurchaseHistoryStatus[] | null;
  neq?: RecurringPurchaseHistoryStatus | null;
  nin?: RecurringPurchaseHistoryStatus[] | null;
}

export interface RecurringPurchaseScheduledTriggerOperationFilterInput {
  eq?: RecurringPurchaseScheduledTrigger | null;
  in?: RecurringPurchaseScheduledTrigger[] | null;
  neq?: RecurringPurchaseScheduledTrigger | null;
  nin?: RecurringPurchaseScheduledTrigger[] | null;
}

export interface RecurringPurchaseSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  amount?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  currencyV2?: CurrencyV2SortInput | null;
  currencyV2Id?: SortEnumType | null;
  id?: SortEnumType | null;
  scheduledTrigger?: SortEnumType | null;
  status?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface RecurringPurchaseStatusOperationFilterInput {
  eq?: RecurringPurchaseStatus | null;
  in?: RecurringPurchaseStatus[] | null;
  neq?: RecurringPurchaseStatus | null;
  nin?: RecurringPurchaseStatus[] | null;
}

export interface ReferralFilterInput {
  and?: ReferralFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: ReferralFilterInput[] | null;
  referralSource?: NullableOfReferralSourceOperationFilterInput | null;
  referredArchivedUserId?: IntOperationFilterInput | null;
  referredEmail?: StringOperationFilterInput | null;
  referredUser?: UserFilterInput | null;
  referredUserId?: IntOperationFilterInput | null;
  sentByUser?: UserFilterInput | null;
  sentByUserId?: IntOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface ReferralSortInput {
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  referralSource?: SortEnumType | null;
  referredArchivedUserId?: SortEnumType | null;
  referredEmail?: SortEnumType | null;
  referredUser?: UserSortInput | null;
  referredUserId?: SortEnumType | null;
  sentByUser?: UserSortInput | null;
  sentByUserId?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface RiaInstitutionFilterInput {
  and?: RiaInstitutionFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  institutionCode?: StringOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: RiaInstitutionFilterInput[] | null;
  riaAdvisors?: ListFilterInputTypeOfUserFilterInput | null;
  riaRelationships?: ListFilterInputTypeOfRiaRelationshipFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface RiaInstitutionSortInput {
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  id?: SortEnumType | null;
  institutionCode?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  name?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface RiaRelationshipFilterInput {
  and?: RiaRelationshipFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: RiaRelationshipFilterInput[] | null;
  riaAdvisor?: UserFilterInput | null;
  riaAdvisorId?: IntOperationFilterInput | null;
  riaClientAccount?: AccountFilterInput | null;
  riaClientAccountId?: IntOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface SecurityAnswerFilterInput {
  and?: SecurityAnswerFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: SecurityAnswerFilterInput[] | null;
  securityQuestion?: SecurityQuestionFilterInput | null;
  securityQuestionId?: IntOperationFilterInput | null;
  text?: StringOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface SecurityQuestionFilterInput {
  and?: SecurityQuestionFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  enabled?: BooleanOperationFilterInput | null;
  group?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: SecurityQuestionFilterInput[] | null;
  text?: StringOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface SendDocumentInput {
  id: number;
}

export interface SendEmailInput {
  accountId?: number | null;
  emailAddresses: EmailAddressInput[];
  fundingId?: number | null;
  fundingV2Id?: number | null;
  htmlContent: string;
  subject: string;
  template?: EmailTemplateType | null;
  userId: number;
}

export interface SmsMessageFilterInput {
  accountId?: IntOperationFilterInput | null;
  and?: SmsMessageFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  deliveredDate?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  failedDate?: DateTimeOperationFilterInput | null;
  failureReason?: StringOperationFilterInput | null;
  fundingId?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  idempotencyId?: StringOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  message?: StringOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: SmsMessageFilterInput[] | null;
  phoneNumber?: StringOperationFilterInput | null;
  sentByUser?: CrmUserFilterInput | null;
  sentByUserId?: IntOperationFilterInput | null;
  sentDate?: DateTimeOperationFilterInput | null;
  status?: SmsStatusOperationFilterInput | null;
  template?: SmsTemplateTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface SmsStatusOperationFilterInput {
  eq?: SmsStatus | null;
  in?: SmsStatus[] | null;
  neq?: SmsStatus | null;
  nin?: SmsStatus[] | null;
}

export interface SmsTemplateTypeOperationFilterInput {
  eq?: SmsTemplateType | null;
  in?: SmsTemplateType[] | null;
  neq?: SmsTemplateType | null;
  nin?: SmsTemplateType[] | null;
}

export interface StakingEnrollmentFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: StakingEnrollmentFilterInput[] | null;
  canceledAt?: DateTimeOperationFilterInput | null;
  completedAt?: DateTimeOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: StakingEnrollmentFilterInput[] | null;
  payoutEligibilityDate?: DateTimeOperationFilterInput | null;
  principle?: DecimalOperationFilterInput | null;
  principleValue?: DecimalOperationFilterInput | null;
  reward?: DecimalOperationFilterInput | null;
  rewardEligibilityDate?: DateTimeOperationFilterInput | null;
  rewardValue?: DecimalOperationFilterInput | null;
  stakedAt?: DateTimeOperationFilterInput | null;
  stakingDepositId?: StringOperationFilterInput | null;
  stakingMovements?: ListFilterInputTypeOfStakingMovementFilterInput | null;
  stakingReward?: StakingRewardFilterInput | null;
  stakingTerm?: StakingTermFilterInput | null;
  stakingTermId?: IntOperationFilterInput | null;
  status?: StakingEnrollmentStatusOperationFilterInput | null;
  unstakedAt?: DateTimeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface StakingEnrollmentSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  canceledAt?: SortEnumType | null;
  completedAt?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  currency?: CurrencyV2SortInput | null;
  currencyId?: SortEnumType | null;
  id?: SortEnumType | null;
  payoutEligibilityDate?: SortEnumType | null;
  principle?: SortEnumType | null;
  principleValue?: SortEnumType | null;
  reward?: SortEnumType | null;
  rewardEligibilityDate?: SortEnumType | null;
  rewardValue?: SortEnumType | null;
  stakedAt?: SortEnumType | null;
  stakingDepositId?: SortEnumType | null;
  stakingReward?: StakingRewardSortInput | null;
  stakingTerm?: StakingTermSortInput | null;
  stakingTermId?: SortEnumType | null;
  status?: SortEnumType | null;
  unstakedAt?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface StakingEnrollmentStatusOperationFilterInput {
  eq?: StakingEnrollmentStatus | null;
  in?: StakingEnrollmentStatus[] | null;
  neq?: StakingEnrollmentStatus | null;
  nin?: StakingEnrollmentStatus[] | null;
}

export interface StakingMovementDirectionOperationFilterInput {
  eq?: StakingMovementDirection | null;
  in?: StakingMovementDirection[] | null;
  neq?: StakingMovementDirection | null;
  nin?: StakingMovementDirection[] | null;
}

export interface StakingMovementFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  amount?: DecimalOperationFilterInput | null;
  and?: StakingMovementFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  direction?: StakingMovementDirectionOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: StakingMovementFilterInput[] | null;
  stakingEnrollment?: StakingEnrollmentFilterInput | null;
  stakingEnrollmentId?: IntOperationFilterInput | null;
  stakingTerm?: StakingTermFilterInput | null;
  stakingTermId?: IntOperationFilterInput | null;
  type?: StakingMovementTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface StakingMovementSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  amount?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  currency?: CurrencyV2SortInput | null;
  currencyId?: SortEnumType | null;
  direction?: SortEnumType | null;
  id?: SortEnumType | null;
  stakingEnrollment?: StakingEnrollmentSortInput | null;
  stakingEnrollmentId?: SortEnumType | null;
  stakingTerm?: StakingTermSortInput | null;
  stakingTermId?: SortEnumType | null;
  type?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface StakingMovementTypeOperationFilterInput {
  eq?: StakingMovementType | null;
  in?: StakingMovementType[] | null;
  neq?: StakingMovementType | null;
  nin?: StakingMovementType[] | null;
}

export interface StakingRewardFilterInput {
  and?: StakingRewardFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  fee?: DecimalOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: StakingRewardFilterInput[] | null;
  rewardAmount?: DecimalOperationFilterInput | null;
  stakingEnrollment?: StakingEnrollmentFilterInput | null;
  stakingEnrollmentId?: IntOperationFilterInput | null;
  totalRewardAmount?: DecimalOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface StakingRewardSortInput {
  createdAt?: SortEnumType | null;
  currency?: CurrencyV2SortInput | null;
  currencyId?: SortEnumType | null;
  fee?: SortEnumType | null;
  id?: SortEnumType | null;
  rewardAmount?: SortEnumType | null;
  stakingEnrollment?: StakingEnrollmentSortInput | null;
  stakingEnrollmentId?: SortEnumType | null;
  totalRewardAmount?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface StakingSourceOperationFilterInput {
  eq?: StakingSource | null;
  in?: StakingSource[] | null;
  neq?: StakingSource | null;
  nin?: StakingSource[] | null;
}

export interface StakingTermFilterInput {
  adminDays?: IntOperationFilterInput | null;
  and?: StakingTermFilterInput[] | null;
  apy?: DecimalOperationFilterInput | null;
  bondingDays?: IntOperationFilterInput | null;
  completedAt?: DateTimeOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  durationDays?: IntOperationFilterInput | null;
  endAt?: DateTimeOperationFilterInput | null;
  enrollmentEndAt?: DateTimeOperationFilterInput | null;
  enrollmentStartAt?: DateTimeOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  minimumPrinciple?: DecimalOperationFilterInput | null;
  or?: StakingTermFilterInput[] | null;
  source?: StakingSourceOperationFilterInput | null;
  startAt?: DateTimeOperationFilterInput | null;
  status?: StakingTermStatusOperationFilterInput | null;
  totalPrinciple?: DecimalOperationFilterInput | null;
  totalRewards?: DecimalOperationFilterInput | null;
  unbondingDays?: IntOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface StakingTermSortInput {
  adminDays?: SortEnumType | null;
  apy?: SortEnumType | null;
  bondingDays?: SortEnumType | null;
  completedAt?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  currency?: CurrencyV2SortInput | null;
  currencyId?: SortEnumType | null;
  durationDays?: SortEnumType | null;
  endAt?: SortEnumType | null;
  enrollmentEndAt?: SortEnumType | null;
  enrollmentStartAt?: SortEnumType | null;
  id?: SortEnumType | null;
  minimumPrinciple?: SortEnumType | null;
  source?: SortEnumType | null;
  startAt?: SortEnumType | null;
  status?: SortEnumType | null;
  totalPrinciple?: SortEnumType | null;
  totalRewards?: SortEnumType | null;
  unbondingDays?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface StakingTermStatusOperationFilterInput {
  eq?: StakingTermStatus | null;
  in?: StakingTermStatus[] | null;
  neq?: StakingTermStatus | null;
  nin?: StakingTermStatus[] | null;
}

export interface StringOperationFilterInput {
  and?: StringOperationFilterInput[] | null;
  contains?: string | null;
  endsWith?: string | null;
  eq?: string | null;
  in?: (string | null)[] | null;
  ncontains?: string | null;
  nendsWith?: string | null;
  neq?: string | null;
  nin?: (string | null)[] | null;
  nstartsWith?: string | null;
  or?: StringOperationFilterInput[] | null;
  startsWith?: string | null;
}

export interface SubscriptionBillingChargeFilterInput {
  and?: SubscriptionBillingChargeFilterInput[] | null;
  chargeBeeInvoiceId?: StringOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  invoiceStatus?: StringOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: SubscriptionBillingChargeFilterInput[] | null;
  paymentAmount?: DecimalOperationFilterInput | null;
  subscriptionBilling?: SubscriptionBillingFilterInput | null;
  subscriptionBillingId?: IntOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface SubscriptionBillingFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  amount?: DecimalOperationFilterInput | null;
  and?: SubscriptionBillingFilterInput[] | null;
  billingDate?: DateTimeOperationFilterInput | null;
  billingFrequency?: SubscriptionBillingFrequencyOperationFilterInput | null;
  billingMethod?: SubscriptionBillingMethodOperationFilterInput | null;
  cancellationDate?: DateTimeOperationFilterInput | null;
  chargeBeeSubscriptionId?: StringOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: SubscriptionBillingFilterInput[] | null;
  status?: SubscriptionBillingStatusOperationFilterInput | null;
  subscriptionBillingCharges?: ListFilterInputTypeOfSubscriptionBillingChargeFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface SubscriptionBillingFrequencyOperationFilterInput {
  eq?: SubscriptionBillingFrequency | null;
  in?: SubscriptionBillingFrequency[] | null;
  neq?: SubscriptionBillingFrequency | null;
  nin?: SubscriptionBillingFrequency[] | null;
}

export interface SubscriptionBillingMethodOperationFilterInput {
  eq?: SubscriptionBillingMethod | null;
  in?: SubscriptionBillingMethod[] | null;
  neq?: SubscriptionBillingMethod | null;
  nin?: SubscriptionBillingMethod[] | null;
}

export interface SubscriptionBillingStatusOperationFilterInput {
  eq?: SubscriptionBillingStatus | null;
  in?: SubscriptionBillingStatus[] | null;
  neq?: SubscriptionBillingStatus | null;
  nin?: SubscriptionBillingStatus[] | null;
}

export interface SystemRoleOperationFilterInput {
  eq?: SystemRole | null;
  in?: SystemRole[] | null;
  neq?: SystemRole | null;
  nin?: SystemRole[] | null;
}

export interface ThemeOperationFilterInput {
  eq?: Theme | null;
  in?: Theme[] | null;
  neq?: Theme | null;
  nin?: Theme[] | null;
}

export interface TourTypeOperationFilterInput {
  eq?: TourType | null;
  in?: TourType[] | null;
  neq?: TourType | null;
  nin?: TourType[] | null;
}

export interface TourTypeWrapperFilterInput {
  and?: TourTypeWrapperFilterInput[] | null;
  or?: TourTypeWrapperFilterInput[] | null;
  tourType?: TourTypeOperationFilterInput | null;
}

export interface TpaRelationshipFilterInput {
  and?: TpaRelationshipFilterInput[] | null;
  custodian?: CustodianFilterInput | null;
  custodianId?: IntOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: TpaRelationshipFilterInput[] | null;
  tpaAccounts?: ListFilterInputTypeOfAccountFilterInput | null;
  tpaUser?: UserFilterInput | null;
  tpaUserId?: IntOperationFilterInput | null;
}

export interface TpaRelationshipSortInput {
  custodian?: CustodianSortInput | null;
  custodianId?: SortEnumType | null;
  id?: SortEnumType | null;
  tpaUser?: UserSortInput | null;
  tpaUserId?: SortEnumType | null;
}

export interface TradeFeeCreditFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: TradeFeeCreditFilterInput[] | null;
  availableBalance?: DecimalOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  lockedBalance?: DecimalOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: TradeFeeCreditFilterInput[] | null;
  totalBalance?: DecimalOperationFilterInput | null;
  tradeFeeCreditHistories?: ListFilterInputTypeOfTradeFeeCreditHistoryFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface TradeFeeCreditHistoryFilterInput {
  and?: TradeFeeCreditHistoryFilterInput[] | null;
  availableBalance?: DecimalOperationFilterInput | null;
  availableBalanceDelta?: DecimalOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  lockedBalance?: DecimalOperationFilterInput | null;
  lockedBalanceDelta?: DecimalOperationFilterInput | null;
  marketOrder?: MarketOrderFilterInput | null;
  marketOrderId?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: TradeFeeCreditHistoryFilterInput[] | null;
  reason?: StringOperationFilterInput | null;
  totalBalance?: DecimalOperationFilterInput | null;
  totalBalanceDelta?: DecimalOperationFilterInput | null;
  tradeFeeCredit?: TradeFeeCreditFilterInput | null;
  tradeFeeCreditId?: IntOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface TradeFeeCreditSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  availableBalance?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  lockedBalance?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  totalBalance?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface TransferringCustodianFilterInput {
  address?: StringOperationFilterInput | null;
  and?: TransferringCustodianFilterInput[] | null;
  city?: StringOperationFilterInput | null;
  conditionalAmount?: IntOperationFilterInput | null;
  conditionalESig?: BooleanOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  email?: StringOperationFilterInput | null;
  faxes?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: TransferringCustodianFilterInput[] | null;
  recentAccountStatementRequired?: BooleanOperationFilterInput | null;
  signatureFormatAccepted?: StringOperationFilterInput | null;
  state?: StringOperationFilterInput | null;
  submissionMethod?: StringOperationFilterInput | null;
  supportsInKind?: BooleanOperationFilterInput | null;
  supportsRollover?: BooleanOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  zipCode?: StringOperationFilterInput | null;
}

export interface TransferringCustodianSortInput {
  address?: SortEnumType | null;
  city?: SortEnumType | null;
  conditionalAmount?: SortEnumType | null;
  conditionalESig?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  device?: SortEnumType | null;
  email?: SortEnumType | null;
  faxes?: SortEnumType | null;
  id?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  iteration?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  name?: SortEnumType | null;
  recentAccountStatementRequired?: SortEnumType | null;
  signatureFormatAccepted?: SortEnumType | null;
  state?: SortEnumType | null;
  submissionMethod?: SortEnumType | null;
  supportsInKind?: SortEnumType | null;
  supportsRollover?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  zipCode?: SortEnumType | null;
}

export interface TreasuryAccountFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: TreasuryAccountFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  employerIdentificationNumber?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  jobTitle?: StringOperationFilterInput | null;
  kybStatus?: StringOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: TreasuryAccountFilterInput[] | null;
  type?: BusinessTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface TreasuryAccountSortInput {
  account?: AccountSortInput | null;
  accountId?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  employerIdentificationNumber?: SortEnumType | null;
  id?: SortEnumType | null;
  jobTitle?: SortEnumType | null;
  kybStatus?: SortEnumType | null;
  name?: SortEnumType | null;
  type?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
}

export interface UpdateAccountDocuSignClickwrapInput {
  clickwrapTemplateType: DocuSignClickwrapTemplateType;
  docuSignDocumentId: string;
}

export interface UpdateAccountInput {
  accountPurpose?: string | null;
  businessJobTitle?: string | null;
  businessName?: string | null;
  businessType?: BusinessType | null;
  businessUrl?: string | null;
  displayName?: string | null;
  docuSignClickwrap?: UpdateAccountDocuSignClickwrapInput | null;
  employerIdentificationNumber?: string | null;
  id: number;
  needsUpdatedIraAgreement?: boolean | null;
  signedUpdatedPcaAgreement?: boolean | null;
  sourceOfFunds?: string | null;
  stage?: AccountStage | null;
  status?: AccountStatus | null;
  taxBitQuestionnaireStatus?: string | null;
  tpaAccountType?: string | null;
  type?: AccountType | null;
  userId?: number | null;
}

export interface UpdateBeneficiaryAddressInput {
  address?: string | null;
  address2?: string | null;
  city?: string | null;
  country?: string | null;
  id?: number | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface UpdateBeneficiaryInput {
  accountHolderRelationship?: string | null;
  accountId?: number | null;
  addresses?: UpdateBeneficiaryAddressInput[] | null;
  dateOfBirth?: any | null;
  dateOfDeath?: any | null;
  directive?: BeneficiaryDirective | null;
  email?: string | null;
  firstName?: string | null;
  id: number;
  isSpousalConsentRequired?: boolean | null;
  lastName?: string | null;
  middleName?: string | null;
  percentage?: any | null;
  phoneNumber?: string | null;
  relationship?: BeneficiaryRelationshipType | null;
  socialSecurityNumber?: string | null;
  spousalConsent?: SpousalConsent | null;
  spousalConsentFormDocumentId?: number | null;
  status?: BeneficiaryStatus | null;
  type?: BeneficiaryType | null;
}

export interface UpdateCrmUserInput {
  email?: string | null;
  firstName?: string | null;
  id?: number | null;
  lastName?: string | null;
  role?: SystemRole | null;
  status?: CrmUserStatus | null;
}

export interface UpdateCrmUserPasswordInput {
  currentPassword?: string | null;
  password?: string | null;
}

export interface UpdateDocumentFileTempInput {
  id: number;
  name?: string | null;
  url?: string | null;
}

export interface UpdateDocumentInput {
  displayName?: string | null;
  docuSignTemplate?: DocuSignTemplateType | null;
  files?: (UpdateDocumentFileTempInput | null)[] | null;
  fileTemplate?: FileTemplateType | null;
  id: number;
  name?: string | null;
  stage?: DocumentStage | null;
  status?: DocumentStatus | null;
  type?: DocumentType | null;
  url?: string | null;
}

export interface UpdateExternalAccountTempInput {
  accountNumber?: string | null;
  accountType?: AccountType | null;
  createdAt?: any | null;
  id: number;
  institutionId?: string | null;
  institutionName?: string | null;
  isPrimary?: boolean | null;
  otherAccountType?: string | null;
  userId?: number | null;
}

export interface UpdateFundingAssetTempInput {
  amount?: any | null;
  currency?: string | null;
  id: number;
  originalBalance?: any | null;
  paymentType?: PaymentType | null;
  requestedAmount?: any | null;
  status?: FundingStatus | null;
  transactionHash?: string | null;
  transferEntireBalance?: boolean | null;
}

export interface UpdateFundingInput {
  associatedFundingId?: number | null;
  beneficiaryId?: number | null;
  contributionType?: ContributionType | null;
  contributionYear?: number | null;
  createdAt?: any | null;
  direction?: FundingDirection | null;
  distributedToClient?: any | null;
  distributionCode?: string | null;
  federalWithholdings?: any | null;
  federalWithholdingsTransactionId?: string | null;
  fromAccountId?: number | null;
  fromExternalAccount?: UpdateExternalAccountTempInput | null;
  fromExternalAccountId?: number | null;
  fundingAssets?: (UpdateFundingAssetTempInput | null)[] | null;
  id: number;
  microTestAmount?: any | null;
  microTestAmountConfirmed?: boolean | null;
  microTestTransactionDate?: any | null;
  microTestTransactionId?: string | null;
  microTransactionRequested?: boolean | null;
  paymentType?: PaymentType | null;
  preventInternalAccount?: boolean | null;
  promoCode?: string | null;
  requestedAmount?: any | null;
  rolloverFrom?: RolloverFromType | null;
  rolloverType?: RolloverType | null;
  sourceCryptoAddress?: string | null;
  stage?: FundingStage | null;
  stateWithholdings?: any | null;
  stateWithholdingsTransactionId?: string | null;
  toAccountId?: number | null;
  toExternalAccount?: UpdateExternalAccountTempInput | null;
  toExternalAccountId?: number | null;
  transactionCode?: string | null;
  transactionDate?: any | null;
  transactionId?: string | null;
  transferringCustodianId?: number | null;
  type?: FundingType | null;
}

export interface UpdateNoteInput {
  id: number;
  status?: NoteStatus | null;
  subject?: string | null;
  text?: string | null;
}

export interface UpdateNotificationSettingInput {
  id: number;
  notificationType: NotificationType[];
}

export interface UpdateReferralInput {
  referralId: number;
  referralSource?: ReferralSource | null;
  sentByUserId?: number | null;
}

export interface UpdateUserInput {
  addresses?: UserAddressInput[] | null;
  alloyEntityToken?: string | null;
  alloyId?: string | null;
  alloyJourneyToken?: string | null;
  astraUserId?: string | null;
  astraUserIntentId?: string | null;
  astraUserIntentStatus?: string | null;
  dateOfBirth?: any | null;
  email?: string | null;
  employerName?: string | null;
  employmentStatus?: EmploymentStatus | null;
  enableNotifications?: boolean | null;
  firstName?: string | null;
  fortressIdentityId?: any | null;
  id?: number | null;
  isVip?: boolean | null;
  jobTitle?: string | null;
  kycStatus?: KycStatus | null;
  lastName?: string | null;
  maritalStatus?: MaritalStatus | null;
  middleName?: string | null;
  needsUpdatedTos?: boolean | null;
  phone?: string | null;
  priorNames?: string | null;
  promoCode?: string | null;
  socialSecurityNumber?: string | null;
  status?: UserStatus | null;
  suffix?: Suffix | null;
}

export interface UpdateUserKycInput {
  id?: number | null;
}

export interface UserAddressFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  address?: StringOperationFilterInput | null;
  address2?: StringOperationFilterInput | null;
  and?: UserAddressFilterInput[] | null;
  city?: StringOperationFilterInput | null;
  country?: StringOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: UserAddressFilterInput[] | null;
  state?: StringOperationFilterInput | null;
  type?: AddressTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
  zipCode?: StringOperationFilterInput | null;
}

export interface UserAddressInput {
  address: string;
  address2?: string | null;
  city: string;
  country?: string | null;
  state: string;
  type: AddressType;
  zipCode: string;
}

export interface UserFilterInput {
  accounts?: ListFilterInputTypeOfAccountFilterInput | null;
  activatedAt?: DateTimeOperationFilterInput | null;
  activeTours?: ListFilterInputTypeOfTourTypeWrapperFilterInput | null;
  addresses?: ListFilterInputTypeOfUserAddressFilterInput | null;
  age?: IntOperationFilterInput | null;
  and?: UserFilterInput[] | null;
  beneficiaries?: ListFilterInputTypeOfBeneficiaryFilterInput | null;
  chargeBeeId?: StringOperationFilterInput | null;
  contractSigned?: DateTimeOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  custodianAccounts?: ListFilterInputTypeOfCustodianAccountFilterInput | null;
  dateOfBirth?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  documents?: ListFilterInputTypeOfDocumentFilterInput | null;
  email?: StringOperationFilterInput | null;
  emailVerifiedAt?: DateTimeOperationFilterInput | null;
  employerName?: StringOperationFilterInput | null;
  employmentStatus?: NullableOfEmploymentStatusOperationFilterInput | null;
  enableNotifications?: BooleanOperationFilterInput | null;
  externalAccounts?: ListFilterInputTypeOfExternalAccountFilterInput | null;
  firstName?: StringOperationFilterInput | null;
  fortressIdentityId?: UuidOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  identification?: IdentificationFilterInput | null;
  identificationId?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  isVip?: BooleanOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  jobTitle?: StringOperationFilterInput | null;
  kycEvaluations?: ListFilterInputTypeOfKycEvaluationFilterInput | null;
  kycStatus?: KycStatusOperationFilterInput | null;
  lastName?: StringOperationFilterInput | null;
  maritalStatus?: NullableOfMaritalStatusOperationFilterInput | null;
  marketingAttribute?: MarketingAttributeFilterInput | null;
  marketingEvents?: ListFilterInputTypeOfMarketingEventFilterInput | null;
  middleName?: StringOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  needsUpdatedTos?: BooleanOperationFilterInput | null;
  notificationSettings?: ListFilterInputTypeOfNotificationSettingFilterInput | null;
  or?: UserFilterInput[] | null;
  passwordChangedOn?: DateTimeOperationFilterInput | null;
  phone?: StringOperationFilterInput | null;
  priorNames?: StringOperationFilterInput | null;
  referralCode?: StringOperationFilterInput | null;
  referralCodeCount?: IntOperationFilterInput | null;
  referrals?: ListFilterInputTypeOfReferralFilterInput | null;
  referredReferral?: ReferralFilterInput | null;
  riaInstitution?: RiaInstitutionFilterInput | null;
  riaInstitutionId?: IntOperationFilterInput | null;
  role?: SystemRoleOperationFilterInput | null;
  salesForceAccountId?: StringOperationFilterInput | null;
  salesForceLeadId?: StringOperationFilterInput | null;
  securityAnswers?: ListFilterInputTypeOfSecurityAnswerFilterInput | null;
  servicePin?: StringOperationFilterInput | null;
  servicePinGeneratedAt?: DateTimeOperationFilterInput | null;
  socialSecurityNumber?: StringOperationFilterInput | null;
  stage?: UserStageOperationFilterInput | null;
  status?: UserStatusOperationFilterInput | null;
  subscriptionBillings?: ListFilterInputTypeOfSubscriptionBillingFilterInput | null;
  suffix?: NullableOfSuffixOperationFilterInput | null;
  tpaRelationships?: ListFilterInputTypeOfTpaRelationshipFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  userPreferences?: UserPreferencesFilterInput | null;
  userPreferencesId?: IntOperationFilterInput | null;
  userStageHistories?: ListFilterInputTypeOfUserStageHistoryFilterInput | null;
  watchCurrencies?: ListFilterInputTypeOfWatchCurrencyFilterInput | null;
}

export interface UserPreferencesFilterInput {
  accountsOrder?: ListFilterInputTypeOfAccountOrderWrapperFilterInput | null;
  and?: UserPreferencesFilterInput[] | null;
  canSolicit?: BooleanOperationFilterInput | null;
  defaultAccount?: AccountFilterInput | null;
  defaultAccountId?: IntOperationFilterInput | null;
  disableThirdPartyPersonalDataTracking?: BooleanOperationFilterInput | null;
  hideDust?: BooleanOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: UserPreferencesFilterInput[] | null;
  theme?: ThemeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface UserPreferencesSortInput {
  canSolicit?: SortEnumType | null;
  defaultAccount?: AccountSortInput | null;
  defaultAccountId?: SortEnumType | null;
  disableThirdPartyPersonalDataTracking?: SortEnumType | null;
  hideDust?: SortEnumType | null;
  id?: SortEnumType | null;
  theme?: SortEnumType | null;
  user?: UserSortInput | null;
  userId?: SortEnumType | null;
}

export interface UserSortInput {
  activatedAt?: SortEnumType | null;
  age?: SortEnumType | null;
  chargeBeeId?: SortEnumType | null;
  contractSigned?: SortEnumType | null;
  createdAt?: SortEnumType | null;
  dateOfBirth?: SortEnumType | null;
  device?: SortEnumType | null;
  email?: SortEnumType | null;
  emailVerifiedAt?: SortEnumType | null;
  employerName?: SortEnumType | null;
  employmentStatus?: SortEnumType | null;
  enableNotifications?: SortEnumType | null;
  firstName?: SortEnumType | null;
  fortressIdentityId?: SortEnumType | null;
  id?: SortEnumType | null;
  identification?: IdentificationSortInput | null;
  identificationId?: SortEnumType | null;
  ipAddress?: SortEnumType | null;
  isVip?: SortEnumType | null;
  iteration?: SortEnumType | null;
  jobTitle?: SortEnumType | null;
  kycStatus?: SortEnumType | null;
  lastName?: SortEnumType | null;
  maritalStatus?: SortEnumType | null;
  marketingAttribute?: MarketingAttributeSortInput | null;
  middleName?: SortEnumType | null;
  modifiedByRole?: SortEnumType | null;
  modifiedByUserId?: SortEnumType | null;
  needsUpdatedTos?: SortEnumType | null;
  passwordChangedOn?: SortEnumType | null;
  phone?: SortEnumType | null;
  priorNames?: SortEnumType | null;
  referralCode?: SortEnumType | null;
  referralCodeCount?: SortEnumType | null;
  referredReferral?: ReferralSortInput | null;
  riaInstitution?: RiaInstitutionSortInput | null;
  riaInstitutionId?: SortEnumType | null;
  role?: SortEnumType | null;
  salesForceAccountId?: SortEnumType | null;
  salesForceLeadId?: SortEnumType | null;
  servicePin?: SortEnumType | null;
  servicePinGeneratedAt?: SortEnumType | null;
  socialSecurityNumber?: SortEnumType | null;
  stage?: SortEnumType | null;
  status?: SortEnumType | null;
  suffix?: SortEnumType | null;
  updatedAt?: SortEnumType | null;
  userPreferences?: UserPreferencesSortInput | null;
  userPreferencesId?: SortEnumType | null;
}

export interface UserStageHistoryFilterInput {
  and?: UserStageHistoryFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: UserStageHistoryFilterInput[] | null;
  stage?: UserStageOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface UserStageOperationFilterInput {
  eq?: UserStage | null;
  in?: UserStage[] | null;
  neq?: UserStage | null;
  nin?: UserStage[] | null;
}

export interface UserStatusOperationFilterInput {
  eq?: UserStatus | null;
  in?: UserStatus[] | null;
  neq?: UserStatus | null;
  nin?: UserStatus[] | null;
}

export interface UuidOperationFilterInput {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: (any | null)[] | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: (any | null)[] | null;
  nlt?: any | null;
  nlte?: any | null;
}

export interface WalletFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: WalletFilterInput[] | null;
  availableBalance?: DecimalOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  lockedBalance?: DecimalOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: WalletFilterInput[] | null;
  totalBalance?: DecimalOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  walletHistories?: ListFilterInputTypeOfWalletHistoryFilterInput | null;
}

export interface WalletHistoryFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: WalletHistoryFilterInput[] | null;
  availableBalance?: DecimalOperationFilterInput | null;
  availableBalanceDelta?: DecimalOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  lockedBalance?: DecimalOperationFilterInput | null;
  lockedBalanceDelta?: DecimalOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: WalletHistoryFilterInput[] | null;
  reason?: StringOperationFilterInput | null;
  totalBalance?: DecimalOperationFilterInput | null;
  totalBalanceDelta?: DecimalOperationFilterInput | null;
  unitPrice?: DecimalOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  updatedById?: IntOperationFilterInput | null;
  updatedByType?: NullableOfWalletUpdateTypeOperationFilterInput | null;
  usdEquivalent?: DecimalOperationFilterInput | null;
  wallet?: WalletFilterInput | null;
  walletId?: IntOperationFilterInput | null;
}

export interface WatchCurrencyFilterInput {
  and?: WatchCurrencyFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currencyV2?: CurrencyV2FilterInput | null;
  currencyV2Id?: IntOperationFilterInput | null;
  device?: StringOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  ipAddress?: StringOperationFilterInput | null;
  iteration?: IntOperationFilterInput | null;
  modifiedByRole?: StringOperationFilterInput | null;
  modifiedByUserId?: IntOperationFilterInput | null;
  or?: WatchCurrencyFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  user?: UserFilterInput | null;
  userId?: IntOperationFilterInput | null;
}

export interface YieldEnrollmentFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: YieldEnrollmentFilterInput[] | null;
  canceledAt?: DateTimeOperationFilterInput | null;
  completedAt?: DateTimeOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  earliestRedemptionAt?: DateTimeOperationFilterInput | null;
  earningAt?: DateTimeOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: YieldEnrollmentFilterInput[] | null;
  payoutEligibilityDate?: DateTimeOperationFilterInput | null;
  principle?: DecimalOperationFilterInput | null;
  principleReturned?: DecimalOperationFilterInput | null;
  principleReturnedAt?: DateTimeOperationFilterInput | null;
  principleValue?: DecimalOperationFilterInput | null;
  reward?: DecimalOperationFilterInput | null;
  rewardEligibilityDate?: DateTimeOperationFilterInput | null;
  rewardValue?: DecimalOperationFilterInput | null;
  status?: YieldEnrollmentStatusOperationFilterInput | null;
  unenrolledAt?: DateTimeOperationFilterInput | null;
  unenrollingAt?: DateTimeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  yieldMovements?: ListFilterInputTypeOfYieldMovementFilterInput | null;
  yieldProduct?: YieldProductFilterInput | null;
  yieldProductId?: IntOperationFilterInput | null;
  yieldReward?: YieldRewardFilterInput | null;
}

export interface YieldEnrollmentStatusOperationFilterInput {
  eq?: YieldEnrollmentStatus | null;
  in?: YieldEnrollmentStatus[] | null;
  neq?: YieldEnrollmentStatus | null;
  nin?: YieldEnrollmentStatus[] | null;
}

export interface YieldInvestorFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  and?: YieldInvestorFilterInput[] | null;
  approvalDate?: DateTimeOperationFilterInput | null;
  areAllParticipantsAccredited?: BooleanOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  estimatedInvestments?: DecimalOperationFilterInput | null;
  hasIncome?: BooleanOperationFilterInput | null;
  hasLicenses?: BooleanOperationFilterInput | null;
  hasNetWorth?: BooleanOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  investor?: InvestorFilterInput | null;
  investorId?: IntOperationFilterInput | null;
  isCompanyExecutive?: BooleanOperationFilterInput | null;
  isFamilyClientFamilyOffice?: BooleanOperationFilterInput | null;
  isKnowledgeableEmployee?: BooleanOperationFilterInput | null;
  or?: YieldInvestorFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
}

export interface YieldMovementDirectionOperationFilterInput {
  eq?: YieldMovementDirection | null;
  in?: YieldMovementDirection[] | null;
  neq?: YieldMovementDirection | null;
  nin?: YieldMovementDirection[] | null;
}

export interface YieldMovementFilterInput {
  account?: AccountFilterInput | null;
  accountId?: IntOperationFilterInput | null;
  amount?: DecimalOperationFilterInput | null;
  and?: YieldMovementFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  direction?: YieldMovementDirectionOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: YieldMovementFilterInput[] | null;
  type?: YieldMovementTypeOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  yieldEnrollment?: YieldEnrollmentFilterInput | null;
  yieldEnrollmentId?: IntOperationFilterInput | null;
}

export interface YieldMovementTypeOperationFilterInput {
  eq?: YieldMovementType | null;
  in?: YieldMovementType[] | null;
  neq?: YieldMovementType | null;
  nin?: YieldMovementType[] | null;
}

export interface YieldProductFilterInput {
  and?: YieldProductFilterInput[] | null;
  closesAt?: DateTimeOperationFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  enabledProductTypes?: ListFilterInputTypeOfProductTypeWrapperFilterInput | null;
  estimatedNetEarningRate?: DecimalOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  maximumEnrollments?: IntOperationFilterInput | null;
  minimumEnrollmentUsd?: DecimalOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  nextOpensAt?: DateTimeOperationFilterInput | null;
  opensAt?: DateTimeOperationFilterInput | null;
  or?: YieldProductFilterInput[] | null;
  type?: StringOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  yieldProductStatus?: YieldProductStatusFilterInput | null;
  yieldProductStatusId?: IntOperationFilterInput | null;
}

export interface YieldProductStatusFilterInput {
  and?: YieldProductStatusFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: YieldProductStatusFilterInput[] | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  yieldProducts?: ListFilterInputTypeOfYieldProductFilterInput | null;
}

export interface YieldRewardFilterInput {
  and?: YieldRewardFilterInput[] | null;
  createdAt?: DateTimeOperationFilterInput | null;
  currency?: CurrencyV2FilterInput | null;
  currencyId?: IntOperationFilterInput | null;
  fee?: DecimalOperationFilterInput | null;
  id?: IntOperationFilterInput | null;
  or?: YieldRewardFilterInput[] | null;
  rewardAmount?: DecimalOperationFilterInput | null;
  totalRewardAmount?: DecimalOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  yieldEnrollment?: YieldEnrollmentFilterInput | null;
  yieldEnrollmentId?: IntOperationFilterInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
